import {countries} from "@/locale/countries";
import {E_SERVICE_PROVIDER_TAG_TYPES} from "@/model/Service/serviceProviderInterfaces";

const messages = {
  locale: 'es-ES',
  localeFallbacks: [
    'en-GB',
  ],
  countries: countries,

  home: {
    welcome: 'Bienvenido al Backoffice de SmartPoint',
    subtitle: 'Selecciona una sección del menú o usa los accesos directos',
    shortcuts: {
      lockers: 'SmartPoints',
      users: 'Usuarios',
      orders: 'Pedidos',
      providers: 'Proveedores',
      reports: 'Informes',
      settings: 'Ajustes',
    },
  },

  common: {
    community: 'Comunidad',
    quantity: 'Cantidad',
    active: 'Activo',
    address: 'Direccion',
    all: 'Todos',
    assigned: 'Asignado',
    autoGenerated: 'Generado automaticamente',
    applyFilter: 'Aplicar filtro',
    back: 'Volver',
    cancel: 'Cancelar',
    close: 'Cerrar',
    clickToAdd: 'Pulsa para añadir',
    colorPicker: 'Elige un color',
    comingUp: 'proximamente',
    confirmDelete: {
      title: "Borrar articulo",
      description: "No se puede deshacer. ¿Estás Seguro?"
    },
    delete: "Eliminar",
    confirmOperation: 'Confirmar operacion',
    contact: 'Contacto',
    count: 'Total',
    createdAt: 'Creado',
    date: 'Fecha',
    today: 'Hoy',
    yesterday: 'Ayer',
    deleted: 'Borrado',
    notDeleted: 'No eliminados',
    // FFS
    create: 'Crear',
    description: 'Descripcion',
    details: 'Detalles',
    recordDetails: 'Detalles del registro',
    dni: 'DNI/NIF/NIE',
    edit: 'Editar',
    email: 'Email',
    error: 'Error',
    required: 'Este campo es obligatorio.',
    validation: {
      required: 'Este campo es obligatorio.',
      min: 'Mínimo {min} caracteres.',
      numeric: 'Debe ser un número válido.',
    },
    errorHappened: 'Se ha producido un error.',
    errorImg: 'La imagen no ha podido ser cargada',
    expiresAt: 'Caduca',
    features: 'Habilidades',
    fileNotFound: 'Fichero no encontrado',
    filters: 'Filtros',
    filterSaved: 'Filtro Guardado',
    filterApplied: 'Filtro Aplicado',
    finish: 'Finalizar',
    from: 'Desde',
    id: 'ID',
    language: 'Idioma',
    languageCodes: {
      en: 'Inglés',
      es: 'Espaňol',
      ca: 'Catalan',
    },
    loading: 'cargando...',
    locker: 'Smart Point',
    map: 'Mapa',
    maxPrice: 'Precio máximo',
    minPrice: 'Precio mínimo',
    more: 'Más',
    name: 'Nombre',
    'new': 'Nuevo',
    next: 'Siguiente',
    noData: 'No hay datos',
    organization: 'Organización',
    noItems: 'Sin articulos',
    noLuck: 'Sin suerte',
    note: 'Nota',
    notSet: 'No determinado (selecciona una)',
    ok: 'OK',
    onCommunities: 'En comunidad',
    onLockers: 'En   Smart Points',
    onlyActive: 'Sólo activos',
    onlyAssigned: 'Sólo asignados',
    order: 'Orden',
    ownTitle: 'Tú mismo',
    price: 'Precio',
    provider: 'Proveedor',
    providers: 'Proveedores',
    reasonWhy: 'Facilita la razon porqué',
    refresh: 'Refrescar',
    save: 'Guardar',
    saved: 'Guardado OK',
    saveFilter:'Guardar filtro',
    search: 'Buscar',
    serviceProvider: 'Proveedor',
    serviceProviders: 'Proveedores',
    settings: 'Ajustes',
    show: 'Mostrar',
    showAll: 'Mostrar todo',
    showMore: 'Mostrar mas',
    skip: 'Saltar',
    slug: "Slug",
    status: 'Estado',
    uptime: 'Tiempo activo',
    type: 'Tipo',
    typeToSearch: 'type to search',
    to: 'Hasta',
    tooShort: 'sigue tecleando...',
    unknown: 'Desconocido',
    updatedAt: 'Actualizado',
    uploadImage: {
      title: 'Confirma cargar image?',
      description: 'has seleccionado:',
      success: 'Image guardado',
      loginNeeded: 'Si ves este mensaje, probablemente tendras que hacer login de nuevo',
      clickOrDragHere: 'pincha para cargar una foto',
      clickOrDragToUpload: 'pincha en la caja para cargar una nueva imagen',
    },
    url: 'URL',
    user: 'Usuario',
    verifiedOK: 'Verificado',
    verifiedKO: 'Aún no verificado',
    when: 'Cuando',
    where: 'Donde',
    yes: 'Sí',
    no: 'No',

    CTA: {
      chooseCellSize: 'Elige tamano de compartimento',
      clickToChange: 'Pulsa para cambiar',
      clickToCopy: 'Pulsa para copiar',
      clickToDownload: 'Pulsa para descargar',
      clickToEdit: 'Pulsa para editar',
      clickToFilter: 'Pulsa para aplicar filtro',
      clickToOpenInNew: 'Pulsa para abrir en pestaňa nueva',
      contextMenu: 'Click derecha / apretar para ver opciones',
      'delete': 'Click para borrar',
      detailsOrEdit: {
        title: 'Detalles / editar',
        description: 'Ver detalles, cambiar ajuestes, cargar fotos, etc.',
      },
      edit: 'Editar detalles',
      gotoOld: 'Volver al pagina antigua',
      showOnlyActive: 'Mostrar solo los activos',
      view: 'Mostrar detalles',
    },
    cta: { // bonomo refers cta as lowercase
      showMore: 'Mostrar mas',
      showAll: {
        hintOn: 'Mostrando todos los sujetos, incluyendo los de prueba. Click para ocultarlos',
        hintOff: 'Los sujetos de prueba son ocultados. Click para mostrarlos.',
      },
      showDeleted: {
        hintOn: 'Mostrando todos los sujetos, incluyendo los eliminados. Click para ocultarlos',
        hintOff: 'Los sujetos eliminados son ocultados. Click para mostrarlos.',
      },
    },
    logs: {
      title: 'Logs',
      headers: {
        action: 'Accion',
        data: 'Detalles',
        description: 'Descripción',
        when: 'Cuando',
      },
      fields: {
        o: {
          label: 'Origin',
          values: {
            0: 'DESCONOCIDO',
            20: 'IMPORTER',
            21: 'DIFFUSION EXPRESS',
            50: 'CONSOLE',
            51: 'MANUAL',
            52: 'Garbage collector',
            100: 'BAO old backoffice',
            202: 'API_V2 locker',
            203: 'API_V3 locker',
            302: 'INTERNAL_DELIVERY_V2 locker',
            401: 'API_M1 modulo',
            501: 'API_B1 webapp',
            601: 'API_G1',
            611: 'API_H1',
            621: 'API_X1',
            30: 'API_M1 modulo', // kept here for compatibilitiy - been used betwee 2022/10 and 2023/10 and these are not migrated
            9999: 'INTERNAL',
          },
        },
        u: {
          label: 'User',
        },
      },
    },
    weekDays: {
      0: 'todos los dias',
      1: 'Lunes',
      2: 'Martes',
      3: 'Miercoles',
      4: 'Jueves',
      5: 'Viernes',
      6: 'Sabado',
      7: 'Domingo',
      title: 'Dia de semana',
    },
    daysOfWeek: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miercoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sabado',
      sunday: 'Domingo',
    },
    paginator: {
      showing: 'Mostrando',
      of: 'de',
      rowsPerPage: 'Filas listadas',
    }
  },
  help: {
    orderDeleteConfirm: "Borrar el pedido efectivamente cierra el pedido, elimina pagos, etc. Los datos del pedido, como los detalles, historial pertenezcan en la sistema pero el pedido será invisible para los usuarios y para los administradores por defecto. Este operacion no se puede anular.",
    restrictCells: "Esta celda solo estará disponible para los proveedores seleccionados aqui (si existe alguno). La celda no se usará para pedidos de otros proveedores ni en repartos.",
  },
  errors: {
    serviceProvider: {
      title: 'Proveedor de servicios incompleto',
      please: "Por favor",
      brandImage: " añade imagen de Marca",
      logoImage: " añade un logo",
      descriptions: " completa las descripciones",
      and: ' y ',
    },
    image: {
      image_must_be_png: "La imagen tendria que ser un png",
    },
    imageUploaded: {
      image: {
        'mimeTypes:["image/png"]': 'No es un imagen PNG',
        notTransparent: 'No es imagen transparente',
      },
    },
    landingPageCreated: {
      tag: {
        not_found: "La empresa no existe",
      },
    },
    lockerLoaded: {
      machine_number: {
        regex: 'Los números 1000,2000,3000.. no están permitidos',
        not_in: 'Este número no está permitido',
      }
    },
    orderLoaded: {
      _: {
        'closed': 'Este pedido ya esta cerrado',
      },
    },
    serviceProviderLoaded: {
      name: {
        min: 'Min. 5 caracters',
      },
      address_line_1: {
        min: 'Min. 5 caracters',
      },
      _: {
        unique: 'Este proveedor ya está conectado a otro canal. Desconéctalo primero.',
      },
    },
    usersImported: {
      _: {
        504: 'Se parece que el import tarda mucho. Sin embargo, seguimos procesando en segunda plano.',
      },
    },
    webhookCreated: {
      _: {
        unique: 'Un solo webhook por usuario y action',
      },
      url: {
        regex: "La Url ha de empezar con https://",
        url: "Esta Url no es correcta",
        unique: 'Este webhook ya esta siendo usado por otro cliente. Por favor, contacta con el soporte de Smart Point'
      }
    },
    submoduleSaved: {
      name: {
        filled: 'Obligatorio',
      },
      slug: {
        required: 'El nombre necesita letras o números',
        unique: 'Este módulo ya tiene un submódulo con este nombre',
      },
    },
    communityUpdated: {
      submodule_ids: {
        moduleNotEnabled: 'Activa antes el módulo de la opción elegida',
        onePerModule: 'En este módulo solo se puede elegir una opción',
        integrationTypeRequired: 'Elige el tipo de integración',
      },
    },
    general: {
      alpha_dash: "Solo letras, números y guiones",
      distinct: 'Valor repetido',
      email: 'No es un email valido',
      exists: 'Ya no existe. Recarga la página',
      image_must_be_png: "image must be png",
      in: 'Valor invalido',
      integer: 'No es un numero entero',
      min: 'Demasiado corto/poco',
      min_height: 'Demasiado pequeňo (altura)',
      min_width: 'Demasiado pequeňo (ancho)',
      no_file: 'No recibimos el archivo',
      numeric: 'No es un numero',
      phone: 'Not es un telefono valido',
      required: 'Requerido',
      allLabelsMandatory: 'Todas las etiquetas "Nombre" son obligatorias en todos los idiomas.',
      ssh_error: "No se pudo conectar con la máquina",
      unique: 'No es unico',
      cannot_change_locker_for_integration_user: 'La comunidad en la que está el usuario tiene una integración',
      cannot_move_user_to_integration_community: 'La comunidad a la que quieres moverlo tiene una integración',
      cannot_move_yourself_to_integration_community: 'Consulta con tech: estás intentando poner tu usuario en un locker con integración y esto no funciona tan fácilmente.',
      _: {
        404: 'Not found',
        401: 'Sin authorizacion',
        500: 'Algo inesperado ha ocurrido.',
        'service_provider.channel_mismatch': 'El canal de este proveedor no coincide con el canal de la comunidad del locker.',
        'service_provider.community_restricted': 'Este proveedor está limitado a otras comunidades y no puede asignarse a este locker.',
      }
    }
  },
  tabs: {
    titles : {
      auditLogs: 'Audit Logs',
      identityIntegrations: 'Integraciones de identidad',
      identityIntegration: 'Integración de identidad',
      channels: 'Channels',
      translations: 'Traducciones',
      couriers: 'Transportistas',
      home: 'Modulo Backoffice',
      lockersServiceProviders: 'Proveedores en SmartPoint',
      lockerCompaniesList: "Compañias de los Smart points",
      lockersScreensavers: 'Salvapantallas en SmartPoint',
      installList: 'Lista instalaciones',
      installLocker: 'instalacion de SmartPoint',
      lockerList: 'Lockers',
      allStandalonesList: 'Digital Portals',
      locker: 'SmartPoint',
      lockersOrders: 'Pedidos de...',
      lockersEdit: 'Editar locker',
      lockerEdit: 'Editar locker',
      lockerCreate: 'Crear locker',
      lockersContracts: 'Contratos',
      lockersContractsCreate: 'Crear contrato',
      lockersContract: 'Contrato de Smart Point',
      lockersLandingpages: 'Landing pages / pisos / etc',
      lockersUsers: 'Usuarios del SmartPoint: ',
      packagesToTransfer: 'Pedidos para transferir',
      orderList: 'Pedidos',
      orderCreate: 'Nuevo pedido',
      orderEdit: 'Editar pedido',
      orderPrint: 'Imprimir pedido',
      subscriptionList: 'Suscripciones',
      order: 'Pedido',
      invoiceList: 'Albaranes',
      invoice: 'Albarán',
      realtime: "The dahsboard",
      userPackageDelivery: 'Recepción de paquetes de usuario',
      permissionMap: 'Mapa de permisos',
      permissionWhoHas: 'Quien tiene (permisos)',
      reports: 'Reports',
      screensavers: 'Salvapantallas',
      screensaverInfo: 'Logs de los salvapantallas',
      screensaverCreate: 'Crear salvapantallas',
      screensaversLockers: 'Salvapantallas en Smartpoint',
      serviceProviderList: 'Proveedores',
      serviceProviderCreate: 'Crear proveedor',
      serviceProvider: 'Proveedor',
      serviceProvidersServices: 'Servicios de proveedor',
      serviceCreate: 'Crear servicio',
      serviceEdit: 'Editar servicio',
      serviceProvidersPromotions: 'Promociones del proveedor',
      serviceProvidersLockers: 'Proveedores en Smart Point',
      serviceProviderCategories: 'Categorias de proveedores',
      serviceProviderTimeLine: 'Time Line',
      serviceProviderMetrics: 'Métricas Mensuales',
      deliverySettings: 'Ajustes de entrega',
      themes: 'Temas',
      themeEdit: 'Editar tema',
      holidays: 'Festivos',
      landingpages: 'Landing pages',
      zones: 'Zonas',
      zone: 'Zona',
      swaggerUi: 'Swagger UI',
      userImport: 'Plataforma de difusion',
      diffusionExpress: 'Difusion express',
      userList: 'Usuarios',
      user: 'Usuario',
      userEdit: 'Editar usuario',
      userCommunications: 'Comunicaciones',
      userPermissions: 'Permisos',
      userPromotions: 'Promociones',
      userOrderLists: 'Órdenes',
      userAddresses: 'Direcciones',
      userMgm: 'MGM',
      userWebhooks: 'Webhooks',
      userAuditLogs: 'Audit Logs',
      lockerFeatures: 'Habilidades',
      standalonesList: 'Standalones',
      communityStandalonesList: 'Digital Portals',
      standalonePreview: 'Preview standalone',
      sshconnections: 'Conexiones SSH',
      businessClientList: 'Clientes',
      businessClientCreate: 'Nuevo Cliente',
      businessClient: 'Cliente',
      businessClientEdit: 'Editar Cliente',
      businessClientCommunities: 'Comunidades del Cliente',
      communityList: 'Comunidades',
      communityCreate: 'Nueva Comunidad',
      community: 'Comunidad',
      communityEdit: 'Editar Comunidad',
      communityModule: 'Módulo de la Comunidad',
      communityLockers: 'SmartPoints de Comunidad',
      communityB2bInvites: 'Invitation Links',
      communityContacts: 'Contactos de Comunidad',
      communityOrders: 'Pedidos de Comunidad',
      communityServiceProviders: 'Proveedores de la Comunidad',
      communityUsers: 'Usuarios de la Comunidad',
      route: 'Rutas',
      routeList: 'Lista de rutas',
      routeEdit: 'Editar ruta',
      routeCreate: 'Crear ruta',
      messages: 'Mensajes',
      rentbackSettings: 'Ajustes Rentback',
      rentbackSettingsEdit: 'Editar regla de crédito',
      rentbackList: 'Rentback',
      securityCodeList: 'Pins de seguridad',
      helpdeskDashboard: 'Helpdesk - Panel',
      helpdeskInbox: 'Helpdesk - Inbox',
      helpdeskAccounts: 'Helpdesk - Cuentas Gmail',
      helpdeskTickets: 'Helpdesk - Tickets',
      helpdeskSpam: 'Helpdesk - Filtro Spam',
      helpdeskTicketTypes: 'Helpdesk - Tipos de Ticket',
      helpdeskSent: 'Helpdesk - Enviados',
      helpdeskTemplates: 'Helpdesk - Plantillas',
      helpdeskSignatures: 'Helpdesk - Firmas',
    },
  },

  channels: {
    title: 'Canales',
    fields: {
      comment: {
        title: 'Nota',
      },
      currency: {
        title: 'Moneda',
      },
      payment_provider: {
        title: 'Proveedor de pago',
      },
      requiresDocumentId: {
        title: 'NIE/ID requirido',
      },
    },
    names: {
      0: '???',
      1: 'Smart Point',
      3: 'Lavalocker',
      4: 'Lagoon',
      5: 'Denmark',
      6: 'Germany',
      7: 'Puig',
      8: 'UK',
      9: 'GMP',
      null: 'Sin Canal'
    },
  },
  contracts: {
    contracts: {
      title: 'Contratos de ',
    },
    contract: {
      title: {
        createContract: 'Crear contrato',
        viewContract: 'Contrato #{entityId}',
        editContract: 'Actualizar contrat #{entityId}',
        renewContract: 'Actualiza estos campos para renovar el contrato',
      },
      sections: {
        generalInfo: 'información general',
        invoicing: 'Facturacion',
        costs: 'Gastos',
        payments: 'Pagos',
        additionalInformation:  'Información adicional',
      },
      fields: {
        beginning_contract: {
          label: 'Contrato de inicio',
        },
        client_name: {
          label: "Nombre del cliente",
        },
        contact_person: {
          label: "Persona de contacto",
        },
        cost_center: {
          label: "Centro de costo",
          values: {
            Madrid: 'Madrid',
            Barcelona: 'Barcelona',
          },
        },
        discount: {
          label: 'Descuento',
        },
        end_contract: {
          label: 'Terminar contrato',
        },
        frequency_invoicing: {
          label: 'Frecuencia de facturación',
          values: {
            'monthly': 'mensual',
            'bimonthly': 'bimensual',
            'quarterly': 'trimestral',
            'annual': 'anual',
            'biannual': 'semestral',
          },
        },
        installation_date: {
          label: 'Instalación',
        },
        installation_cost: {
          label: 'Coste de instalación (€)',
        },
        invoice_company: {
          label: "Compañía de facturación",
          values: {
            lavalocker: 'lavalocker',
            sp_income: 'sp_income',
          },
        },
        invoicing_guarantee: {
          label: 'Garantía de facturación',
        },
        invoicing_install: {
          label: 'Instalación de facturación',
        },
        invoicing_maintenance: {
          label: 'Mantenimiento de Facturación',
        },
        invoicing_rental: {
          label: 'Facturación Alquiler',
        },
        invoicing_sales: {
          label: 'Facturación de Ventas',
        },
        IPC_increase_date: {
          label: 'Fecha de aumento del IPC',
        },
        IPC_increase_percentage: {
          label: 'Incremento del IPC (%)',
        },
        key_account_manager_id: {
          label: "KAM",
        },
        locker_condition: {
          label: "Condición de Smart point",
          values: {
            'active': 'activo',
            'inactive': 'inactivo',
          },
        },
        monthly_amount_invoice: {
          label: 'Importe Mensual Factura (€)',
        },
        payment_terms: {
          label: 'Términos de pago',
        },
        production_cost: {
          label: 'Coste de producción (€)',
        },
        renewal_conditions: {
          label: 'Condiciones de renovación',
          values: {
            automatic: 'automatica',
            "agreed by the parties": 'acordada entre partes',
          },
        },
        transaction_type: {
          label: 'Tipo de transacción',
          values: {
            rent: 'alquiler',
            purchase_sale: 'compra',
          },
        },

        discount_reason: {
          label: 'Razon del descuento',
        },
        location: {
          label: 'Ubicacion',
          values: {
            national: 'nacional',
            international: 'internacional',
          },
        },
        invoicing_additional_column: {
          label: 'Facturación columna adicional (€)',
        },
        payment_type: {
          label: 'Tipo de pago',
          values: {
            direct_debit: 'domiciliado',
            transfer: 'transferencia',
            cash: 'efectivo',
            pagare: 'Pagaré',
            cheque: 'cheque',
          },
        },
        renovation_notice_date: {
          label: 'Fecha preaviso notificación',
        },
        expansion_renovation: {
          label: 'Ampliación renovación',
        },
        last_renovation_date: {
          label: 'Ultima renovación',
        },
        purchase_order: {
          label: 'PO',
        },
        setup_and_training: {
          label: 'Setup & training (€)',
        },
        rear: {
          label: 'Trasera',
        },
        extra_costs: {
          label: 'Gastos extras (€)',
        },
        potential: {
          label: 'Potencial',
        },
      },
    },
  },
  invoices: {
    titleGeneral: 'Facturas',
    list: {
      title: 'Facturas',
      filterAll: 'Todas',
      filterNew: 'Pendientes',
      filterPaid: 'Pagadas',
      noItems: 'No se encontraron facturas',
      searchPlaceholder: 'ID, cliente o proveedor...',
    },
    detail: {
      title: 'Albarán',
      orders: 'Pedidos',
      payments: 'Pagos',
      communications: 'Comunicaciones',
      commType: 'Tipo',
      commStatus: 'Estado',
      commContent: 'Mensaje',
      customer: 'Cliente',
      serviceProvider: 'Proveedor de servicio',
      totals: 'Totales',
      grandTotal: 'Total',
      subTotal: 'Subtotal',
      vat: 'IVA',
      hasPdf: 'PDF disponible',
      noPdf: 'Sin PDF todavía',
      date: 'Fecha',
      fieldName: 'Nombre',
      fieldEmail: 'Email',
      fieldCompany: 'Empresa',
      fieldNie: 'NIE',
      fieldAddress: 'Dirección de facturación',
    },
    create: {
      title: 'Nuevo albarán',
    },
    actions: {
      sendEmail: 'Enviar factura',
      addPayment: 'Registrar pago',
      delete: 'Eliminar factura',
      create: 'Crear factura',
      edit: 'Editar pedidos',
    },
    payment: {
      amount: 'Importe',
      date: 'Fecha',
      title: 'Añadir pago',
    },
    statuses: {
      invoice_new: 'Nueva',
      invoice_awaiting_payment: 'Esperando pago',
      invoice_paid: 'Pagada',
    },
    editOrders: {
      available: 'Pedidos disponibles',
      selected: 'Pedidos seleccionados',
      emptyAvailable: 'No hay pedidos disponibles',
      emptySelected: 'Arrastra pedidos aquí para añadirlos',
    },
    errors: {
      invoice_without_orders: 'No hay pedidos seleccionados',
      missing_billing_information: 'El cliente no tiene datos de facturación (NIE / nombre empresa)',
      missing_default_billing_address: 'El cliente no tiene dirección de facturación por defecto',
      missing_service_provider: 'El pedido no tiene proveedor de servicio asignado',
      missing_sp_invoicing_address: 'El proveedor no tiene dirección de facturación',
      invoice_without_customer: 'La factura no tiene cliente',
      wrong_amount_specified: 'Importe no válido',
    },
  },
  landingPages:{
    titleOf: 'Landing pages de',
    createDialog: {
      title: "Crear nuevo landing page",
      slug: "Slug",
      tag: "Tag",
    },
  },
  lockers: {
    cells: {
      restrictionsDialog: {
        title: "Restricciones de celda",
      },
      sizeNames: {
        3: 'Pequeño',
        2: 'Mediano',
        4: 'Grande',
        5: 'XL',
        1: 'XXL',
      },
      direction: {
        left: 'left',
        right: 'right',
        below: 'under',
        under: 'under',
        center: 'under',
      }
    },
    featureList: {
      confirmationDialog: {
        header1: 'Se va a habilitar ',
        header2: 'Se va a deshabilitar ',
        header3: ' en Smart Point ',
      }
    },
    install: {
      search: 'Buscar en todos los campos: nombre, direccion, maquina, version, OS, CPU, estado, ultimo ping',
      title: 'Lista instalaciones',
      csvExportHint: 'Descarga un CSV con todos los Smart Points (vista instalaciones) que coinciden con los filtros actuales.',
      csvLimitTitle: 'Límite de filas alcanzado',
      csvLimitText: 'Estás intentando descargar más de 1000 Smart Points, que es el límite máximo. Aplica filtros para reducir los resultados.',
      external_name: {
        title: 'Nombre externo',
        popUp: {
          title: 'Editar nombre externo',
          hint: 'Nombre con el cual el cliente identifica internamente este SmartPoint',
          help: `El nombre externo se usa para identificar este Smart Point en integraciones SAML`,
        }
      },
      cells: {
        toggle: 'Habilitar / inhabilitar compartimentos',
        oldCells: 'Mostrar/ocultar compartimentos deshabilitados',
        rotateScreen: 'Rotar pantalla',
        default: '(por defecto)',
        orientations: {
          normal: 'Normal',
          right: 'Derecha',
          inverted: 'Invertida',
          left: 'Izquierda',
        },
        toggleSubtitle: 'Los pedidos no reservaran compartimentos deshabilitados',
        connector: 'Conector en placa',
        connectorSubtitle: 'Editar configuración del conector (INSEGURO)',
        id: 'ID de compartimentos',
        idSubtitle: 'Muestra el identificador de un compartimento',
        open: 'Abrir compartimentos',
        openSubtitle: 'Permite abrir los compartimentos de un locker',
        openDialog: {
          title: 'Abrir compartimento #{cell}',
          subtitle: 'La puerta debería estar desbloqueada ahora',
          question: '¿Qué quieres hacer?',
          orderId: 'Pedido #{id}',
          delivered: 'Entregado',
          statusLabel: 'Estado',
          openAndComplete: 'Abrir y completar pedido',
          openCellOnly: 'Solo abrir compartimento',
          cellIsOpen: 'Compartimento abierto',
          cellOpened: '¡Compartimento abierto!',
          orderCompletedToast: '¡Pedido completado!',
          completeOrderQuestion: '¿Completar pedido ahora?',
          completeOrder: 'Sí, completar pedido',
          keepOpenCompleteLater: 'Mantener abierto, completar después',
          orderCompleted: 'Pedido #{id} · {firstName} {lastName} ha sido completado',
          doorStuckTitle: '¿La puerta no abre?',
          doorStuckBody: 'Contacta con soporte e indica el locker y el número de celda.',
        },
        accessibility: 'Marcar/desmarcar celdas accesible',
        accessibilitySubtitle: 'Marca celdas como validas para personas de movilidad reducida',
        features: {
          disabled: 'Deshabilitado. El compartimento no se asignara a pedidos.',
          accessible: 'Apto para clientes con discapacidad',
        },
        restrictCells: 'Restringir celdas',
        restrictCellsSubtitle: 'Para restringir las celdas de los casilleros',
        openConfirm: '¿Seguro que quieres abrir este compartimento?',
        dwellTime: {
          legendFree: 'Libre',
          legendBlocked: 'Bloqueado',
          legendLess24h: 'Ocupado < 24h',
          legend24h: 'Ocupado 24h+',
          legend72h: 'Ocupado 72h+',
        },
        hideColumn: 'Ocultar columna',
        showColumn: 'Mostrar columna',
        columnOrder: 'Orden de columna',
      },
      logo: {
        title: "Cambiar logotipo",
        noMachineNumber: "No se encontró número de máquina (DM-XXXX). Este número es necesario para subir el logo"
      },
      createModule: {
        title: 'Nuevo módulo',
        addColumn: 'Añadir columna',
        restrictUse: 'Restringir uso',
      },
    },
    locker: {
      fields: {
        abbreviation: {
          title: 'Abreviacion',
        },
        channel_id: {
          title: 'Canal',
        },
        community_id: {
          title: 'Comunidad',
        },
        owner_user_id: {
          title: 'Propietario',
        },
        lockerCompanies: {
          title: 'Etiquetas para marketing',
        },
        currency: {
          title: 'Moneda de precios',
        },
        default_phone_prefix: {
          title: 'Prefijo telefono por defecto',
          description: 'Usado en los URL de los landing pages, para la pagina del registro',
        },
        delivery_by_phone: {
          title: 'Reparto por numero de telefono',
        },
        description: {
          title: 'Descripcion',
        },
        directory_deliveries_24: {
          title: 'DD24 multi',
        },
        directory_deliveries_25: {
          title: 'DD25',
        },
        directory_delivery: {
          title: 'Entrega de directorio',
        },
        gateCodes: {
          title: 'Codigos de puerta del edeficio',
        },
        identifier: {
          title: 'Identificador',
        },
        internal_delivery_type: {
          title: 'Reparto interno (OBS)',
        },
        la_liga: {
          title: 'La Liga'
        },
        languages: {
          title: 'Idiomas',
        },
        last_ping: {
          title: 'Ultimo sincronización',
        },
        location_info: {
          title: 'Información de ubicación',
        },
        location_description: {
          title: 'Descripcion del ubicacion del Smart Point',
        },
        location_building_name: {
          title: 'Nombre del edeficio',
        },
        location_building_floor: {
          title: 'Planta',
        },
        locker23_feature: {
          title: 'Diseňo locker23',
        },
        logo_image_id: {
          title: 'Custom logo',
          imageHint: 'El imagen debe tener un tamaňo de 350x70, y ser PNG transparente',
        },
        machine_number: {
          description: "Inserte el número de máquina DM-XXXX aquí",
          title: 'Machine number', // not translated!
        },
        only_local_delivery: {
          title: 'Solo entregas locales',
          description: 'solo usuarios del locker pueden tener entregas',
        },
        os_version: {
          title: 'OS Version',
        },
        os_memory: {
          title: 'Memoria',
        },
        os_cpu: {
          title: 'Cpu',
        },
        should_send_reminders: {
          title: 'Enviar recordatorios',
          description: 'Si recordatorios de recogidas deben enviarse para pedidos de este Smart Point',
        },
        sim: {
          title: 'Identificador SIM',
          saved: 'Codificación SIM guardada',
        },
        status: {
          title: 'Estado',
        },
        theme_name: {
          title: 'Tema (OBS)',
        },
        version: {
          title: 'Versión',
        },
        vertical: {
          title: 'Vertical',
          values: {
            10: 'Corporate',
            20: 'Office',
            30: 'Hospital',
            40: 'Residential',
            50: 'Student',
            60: 'Bespoke',
          },
        },
        landing_version: {
          title: 'Landing version',
          values: {
            100: 'Single tenant',
            110: 'Multi tenant',
          },
        },
        screen_type: {
          title: 'Tipo de pantalla',
          applied: 'Aplicado',
          notApplied: 'No aplicado',
          values: {
            big: 'Pantalla grande',
            small: 'Pantalla pequeña',
          },
        },
        zone_id: {
          title: 'Zona',
        },
      },
      create: {
        title: 'Nuevo Smart Point',
      },
      laLiga: {
        errors: {
          end_at: {
            future_date: 'Debe ser una fecha futura',
          },
          start_at: {
            max_today: 'Debe ser hoy o pasado',
            within_past_6_months: 'Maximo los ultimos 6 meses',
          },
        },
        fields: {
          endAt: {
            title: 'Termina',
          },
          startAt: {
            title: 'Empieza'
          },
        },
        title: 'La Liga!',
      },
      landingPages: {
        removeConfirmationDialog: {
          title: "¿Desconectar empresa de este Smart Point?",
          description: "El landing page tambien dejará funcionar.",
        },
        title: 'Landing pages',
        titles: {
          10: 'Departamentos',
          20: 'Empresas',
          30: 'Departamentos',
          40: 'Pisos',
          50: 'Pisos',
          60: 'Pisos',
        },
        unassignedCount: "Usuarios conectados / no conectados",
      },
      logoImage: {
        errors: {
          image: {
            'exactWidth:350': 'La imagen debe ser de 350 px de ancho por 70 px de alto',
            'exactHeight:70': 'La imagen debe ser de 350 px de ancho por 70 px de alto',
          }
        },
        toastOK: 'No olvides empujear el configuracion!',
      },
      module_name: {
        _: 'THESE ARE MODULE TYPE TRANSLATIONS, DO NOT PUT MODULE NAME TRANSLATIONS HERE',
        1: 'Máster',
        2: 'Tintorería',
        3: 'Paquetería',
        4: 'Mix',
        5: 'Master (Z)',
        6: 'Paq (Z)',
        7: 'Mix (Z)',
        8: '5 comp (Z)',
        9: '11 comp (Z)',
        10: '8 comp (Z)',
        11: '7 comp (Z)',
        12: '6 comp (Z)',
        13: '4 comp (Z)',
        14: 'Master +2 (Z)',
        15: 'Master +3 (Z)',
        16: 'Master +4 (Z)',
        17: '10 comp (Z)',
        18: '9 comp (Z)',
        19: '3 comp (Z)',
        20: 'Master +7 (Z)',
        21: '9 comp XL (Z)',
        22: '4 comp (Z)',
        23: '10 comp XL/A (Z)',
        24: '10 comp XL/B (Z)',
        25: '12 comp A (Z)',
        26: '16 Mix (Z)',
        27: '14 Mix (Z)',
        28: '10 Mix Double (Z)',
        29: '15 Mix Double (Z)',
        30: '12 Mix Double (Z)',
        31: '10 Mix comp (Z) ',
        89: 'Totem/pantalla',
        99: 'Desconocido',
      },
      pushConfiguration: {
        title: 'Empujar configuracion',
        confirmationLabel: 'Confirmacion (numero de maquina actual)',
      },
      qr: {
        fields: {
          preset: {
            title: 'Elegir preset:',
          },
          utmCampaign: {
            title: 'UTM campaign',
          },
          utmMedium: {
            title: 'UTM medium',
          },
          utmSource: {
            title: 'UTM source',
          },
          registerLanding: {
            title: 'Mostrar Qr en locker',
          },
        },
        title: 'Generador QR',
        utm: {
          onboarding: {
            title: 'Onboarding Materials',
            campaignName: 'Onboarding',
            // sources: source: title tuples
            sources: {
              vinilo: 'Vinilo',
              flyer: 'Flyer',
              'Roll Up': 'Roll Up',
              Screensaver: 'Screensaver',
              Posters: 'Posters',
              Stickers: 'Stickers',
              'Table tents': 'Table tents',
            },
          },
          welcomePack: {
            title: 'Welcome Pack Materials',
            campaignName: 'welcomepack',
            sources: {
              Flyers: 'Flyers',
              'Screen saver': 'Screen saver',
              Poster: 'Posterl',
              'Roll up': 'Roll Up',
            },
          },
          campaign2: {
            title: 'Campaign 2',
            campaignName: 'welcomepack',
            sources: {
              'Flyers':	'Flyers',
              'Screen saver':	'Screen saver',
              'Poster':	'Posterl',
            },
          }
        },
      },
      reboot: {
        title: 'Reiniciar máquina',
        description: 'Se va a reiniciar la máquina ¿Desea proceder?',
      },
      statuses: {
        title: 'Estado',
        deleted: 'Borrado',
        online: 'Online',
        install: 'En instalación',
        off: 'Offline',
      },
      edit: {
        title: 'Editar Smart Point',
      },
      title: 'Smart Point',
    },
    nav: {
      details: 'Detalles',
      edit: 'Editar',
      cells: 'Compartimentos',
      serviceProviders: 'Proveedores',
      orders: 'Pedidos',
      users: 'Usuarios',
      contracts: 'Contratos',
      transfer: 'Transfer',
      screensavers: 'Salvapantallas',
      landingpages: 'Landing pages',
    },
    lockers: {
      search: 'Buscar en nombre, direccion, version, estado',
      csvExportHint: 'Descarga un CSV con todos los Smart Points que coinciden con los filtros actuales.',
      csvLimitTitle: 'Límite de filas alcanzado',
      csvLimitText: 'Estás intentando descargar más de 1000 Smart Points, que es el límite máximo. Aplica filtros para reducir los resultados.',
      fields: {
        counts: {
          title: 'SP / SS',
          hint: 'proveedores / salvapantallas',
        },
        last_sync: 'Último',
        machine: 'Máquina',
        os_version: 'Versión linux',
        os_memory: 'Cpu / Memoria',
        version: 'Versión',
      }
    },
    standalone: {
      title: 'Portales digitales de: ',
    },
    screensavers: {
      enable_desc: 'Este protector de pantalla estará habilitado en todos los Smart Points. ¿Continuar?',
      disable_desc: 'Este protector de pantalla estará deshabilitado en todos los Smart Points. ¿Continuar?',
    },
    transfers: {
      title: 'Transfer',
      create: 'Aňadir destinos de transfer',
    },
    users: {
      title: 'Usuarios de: ',
    },
  },
  lockersProviders: {
    title: 'Proveedores en SmartPoint',
    titleOnLocker: 'en SmartPoints',
    titleOnCommunity: 'en comunidades',
    descriptionOnLocker: 'Mostrar smartpoints donde este proveedor es disponible',
    showAllServiceProviders: 'Todos Sp',
    communityRestricted: 'Este proveedor está restringido a comunidades específicas y no puede asignarse a este locker',
    channelInconsistency: 'Inconsistencia de canal entre la comunidad y este proveedor de servicio',
  },
  login: {
    title: 'Acceso',
    email: 'Email',
    password: 'Contraseña',
    submit: 'Entrar',
  },
  menu: {
    title: 'Toolbar',
    panel: {
      title: 'Panel',
    },
    orders: {
      title: 'Pedidos',
      list: 'Lista',
      create: 'Nuevo pedido',
      single: 'Pedidos puntuales',
    },
    subscriptions: {
      title: 'Suscripciones',
    },
    routes: {
      title: 'Rutas',
      list: 'Lista',
      create: 'Nueva ruta',
    },
    operations: {
      title: 'Operaciones',
    },
    invoices: {
      title: 'Facturas',
      list: 'Lista',
    },
    users: {
      title: 'Usuarios',
      list: 'Lista',
      details: 'Detalles',
      orders: 'Pedidos',
      promotions: 'Promos',
      communications: 'Comunicaciones',
      addresses: 'Direcciones',
      permissions: 'Permisos',
    },
    userImport: 'Plataforma de difusion',
    diffusionExpress: 'Difusion expres',
    standalone: {
      title: 'Portales digitales',
    },
    standalones: {
      title: 'Portales digitales',
    },
    amenities: {
      title: 'Servicios',
      list: 'Lista',
      metrics: 'Métricas Mensuales',
    },
    clients: {
      title: 'Clientes',
      list: 'Lista',
      create: 'Crear',
    },
    communities: {
      title: 'Comunidades',
      list: 'Lista',
      create: 'Crear',
      securityCodes: 'Pins de seguridad',
    },
    providers: {
      title: 'Proveedores',
      list: 'Lista',
      details: 'Detalles',
      lockers: 'En Smartpoints',
      categories: 'Categorias',
      timeline: 'Logs',
      services: 'Servicios',
      promotions: 'Promociones',
      metrics: 'Métricas Mensuales',
      products: 'Productos',
    },
    lockers: {
      title: 'Lockers',
      install: 'Instalación',
      list: 'Lista',
      details: 'Detalles',
      edit: 'Editar',
      packagesToTransfer: 'Pedidos de transfer',
      providers: 'Proveedores',
      screen_savers: 'Salvapantallas',
      contracts: 'Contratos',
      cells: 'Compartimentos',
    },
    webhooks: {
      title: 'Webhooks',
    },
    reports: {
      title: 'Reports',
      general: 'Informes generales',
      datastudio: 'Informes Datastudio',
      registrations: 'Registros de usuarios',
    },
    companies: {
      title: 'Empresas',
    },
    helpdesk: {
      title: 'Helpdesk',
      dashboard: 'Panel',
      inbox: 'Inbox',
      accounts: 'Cuentas Gmail',
      tickets: 'Tickets',
      spam: 'Filtro Spam',
      ticketTypes: 'Tipos de Ticket',
      sentEmails:  'Enviados',
      templates:   'Plantillas',
      signatures:  'Firmas',
      whatsapp:    'WhatsApp',
    },
    settings: {
      channels: 'Channels',
      modules: 'Módulos',
      title: 'Ajustes',
      translations: 'Traducciones',
      messages: 'Mensajes',
      identityIntegrations: 'Integraciones de identidad',
      deliveries: 'Entregas',
      themes: 'Temas',
      landings: 'Landing pages',
      holidays: 'Festivos',
      zones: 'Zonas',
      couriers: 'Transportistas',
    },
    permissions: {
      title: 'Permisos',
      permissionMap: 'Mapa permisos',
      whoHas: 'Quien tiene...',
    },
    swagger: {
      title: 'Swagger',
      module: 'Swagger/Modulo',
    },
    sshconnection:{
      title: 'Conexiones SSH',
      module: 'Conexiones SSH',
    },
    apiKeys: {
      title: 'API Keys',
      module: 'API Keys',
    },
    auditLogs: {
      title: 'Audit Logs',
      module: 'Audit Logs',
    },
    my_permissions: {
      title: 'Mis permisos',
    },
    logout: {
      title: 'Cerrar sesión',
    },
    rentback: {
      title: 'Rentback',
      nextMonth: 'mes siguiente',
    },
  },
  subscriptions: {
    list: {
      plan:                 'Plan',
      amount:               'Importe',
      currentPeriodEnd:     'Fin de periodo',
      canceledAt:           'Cancelado el',
      ordersCount:          'Pedidos',
      stripeSubscriptionId: 'ID Stripe',
      viewOrders:           'Pedidos',
      cancel:               'Cancelar',
      retry:                'Reintentar',
      reactivate:           'Reactivar',
      renew:                'Renovar',
      confirmCancelText:    'La suscripcion se cancelara al final del periodo actual. Continuar?',
      confirmCancelTitle:   'Cancelar suscripcion',
      confirmCancelConfirm: 'Confirmar cancelacion',
      action_cancel_ok:     'Cancelacion programada correctamente',
      action_retry_ok:      'Reintento de pago lanzado correctamente',
      action_reactivate_ok: 'Suscripcion reactivada correctamente',
      action_renew_ok:      'Suscripcion renovada correctamente',
      renewTitle:           'Renovar suscripcion',
      renewText:            'Se creara una nueva suscripcion en Stripe usando el metodo de pago guardado del cliente.',
      renewConfirm:         'Confirmar renovacion',
      renewAmount:          'Importe',
      billingCycleAnchor:   'Primer cobro estimado',
      cancellationReason:   'Motivo de cancelacion',
      renewedTo:            'Renovada a',
      parentSubscription:   'Padre',
      reactivateTitle:      'Reactivar suscripcion',
      reactivateText:       'Se creara una nueva suscripcion en Stripe usando el metodo de pago guardado del cliente.',
      reactivateConfirm:    'Confirmar reactivacion',
      clearFilters:         'Limpiar filtros',
      ordersModalTitle:     'Pedidos de suscripcion',
      orderTotal:           'Total',
      orderType:            'Tipo',
      orderUser:            'Usuario',
      orderLocker:          'Taquilla',
      orders:               'Pedidos',
      noOrders:             'Sin pedidos asociados',
      results:              'resultados',
      pause:                'Pausar',
      resumeFromPause:      'Reanudar',
      pauseTitle:           'Pausar suscripcion',
      pauseUntilReview:     'Hasta nueva revision (indefinidamente)',
      pauseUntilDate:       'Hasta una fecha concreta',
      pauseResumeDate:      'Fecha de reanudacion',
      confirmPauseConfirm:  'Confirmar pausa',
      pauseText:            'Se pausara la facturacion. No se cobrara ningun pago durante la pausa.',
      action_pause_ok:      'Suscripcion pausada correctamente',
      action_resume_pause_ok: 'Suscripcion reanudada correctamente',
      pauseResumesAt:       'Se reanuda el',
      pauseIndefinite:      'Pausada indefinidamente',
      pauseScheduled:       'Se pausara al fin del periodo',
      refund:                         'Reembolsar',
      refundTitle:                    'Reembolsar pago de suscripcion',
      refundTypeLabel:                'Tipo de reembolso',
      refundTypeFull:                 'Reembolso total',
      refundTypePartial:              'Reembolso parcial',
      refundAmountLabel:              'Importe a reembolsar',
      refundActionLabel:              'Tras el reembolso',
      refundActionRefundAndCancel:    'Reembolsar y cancelar la suscripcion',
      refundActionRefundOnly:         'Solo reembolsar — mantener la suscripcion activa',
      refundLastCharge:               'Ultimo cobro',
      refundAlreadyRefunded:          'Ya reembolsado',
      refundAvailable:                'Importe reembolsable',
      refundInvoiceDate:              'Fecha de factura',
      refundConfirm:                  'Confirmar reembolso',
      action_refund_ok:               'Reembolso procesado correctamente',
      viewRefunds:                    'Reembolsos',
      refundsHistoryTitle:            'Historial de reembolsos',
      refundsHistoryEmpty:            'No hay reembolsos registrados para esta suscripcion',
      refundsHistoryAction:           'Accion',
      refundAndCanceledTag:           'Reembolsado + cancelado',
      refundAmountMin:                'El importe debe ser mayor que 0',
      refundAmountMax:                'Importe maximo reembolsable:',
    },
    statuses: {
      active:             'Activa',
      trialing:           'Prueba',
      past_due:           'Pago vencido',
      canceled:           'Cancelada',
      unpaid:             'Impagada',
      paused:             'Pausada',
      incomplete:         'Incompleta',
      incomplete_expired: 'Expirada',
    },
  },
  orderCreate: {
    title: 'Nuevo pedido manual',
    step1: {
      title: 'Seleccionar cliente',
      searchUser: 'Buscar usuario por nombre, email o ID',
      searchPlaceholder: 'Escribe al menos 3 caracteres (nombre, email o ID)…',
      noResults: 'No se encontraron usuarios',
      selectedUser: 'Cliente seleccionado',
    },
    step2: {
      title: 'Seleccionar ubicación',
      locationTypeLocker: 'Locker',
      locationTypeAddress: 'Dirección del cliente',
      selectLocker: 'Selecciona un locker',
      noLockers: 'No hay lockers accesibles',
      selectAddress: 'Selecciona una dirección',
      noAddresses: 'Este cliente no tiene direcciones registradas',
      loadingAddresses: 'Cargando direcciones…',
    },
    step3: {
      title: 'Añadir servicios',
      noServices: 'No hay servicios disponibles para este locker',
      addedServices: 'Servicios a incluir',
      service: 'Servicio',
      provider: 'Proveedor',
      price: 'Precio',
      quantity: 'Cant.',
      addService: 'Añadir servicio',
      mandatoryLabel: 'Servicios obligatorios',
      genericArticle: 'Artículo genérico',
      genericArticleAdd: 'Añadir artículo genérico',
      genericArticleDescription: 'Descripción',
      genericArticlePrice: 'Precio personalizado',
      genericArticleProvider: 'Proveedor',
      genericArticleMinCompartment: 'Tamaño mínimo del compartimento',
      genericArticleMinCompartmentRequired: 'Necesitamos el campo custom locker cell size id para continuar',
      genericArticleNoCompartment: 'Sin compartimento',
      promoCode: 'Código promocional (opcional)',
      note: 'Nota interna (opcional)',
      initialStatusLabel: 'Estado inicial del pedido',
      initialStatusPickup: 'Esperando recogida',
      initialStatusConfirm: 'Confirmación de pedido',
      initialStatusRequired: 'Selecciona el estado inicial del pedido',
      create: 'Crear pedido',
    },
  },
  orders: {
    viewOrderDetails: 'Ver detalles del pedido',
    order: {
      title: 'Pedido',
      statuses: {
        status_order_new: 'Nuevo',
        status_awaiting_customer_dropoff: 'Esperando depositar artículos',
        status_order_awaiting_collect: 'Esperando recogida',
        status_order_in_route_collect: 'En ruta para recoger',
        status_order_sp_collected: 'Recogido y en proceso',
        status_order_in_progress: 'En progreso',
        status_order_assembled: 'Preparado y listo para entregar',
        status_order_in_route_delivery: 'En ruta para entregar',
        status_order_sp_delivered: 'Entregado y en la taquilla',
        status_order_completed: 'Pedido completo',
        status_order_professional_search: 'Buscando profesional',
        status_order_professional_confirmed: 'Profesional confirmado',
        // not used at the moment
        status_order_delayed: '',
        status_order_sp_cancelled: '',
        status_order_client_cancelled: 'Cancelado por el cliente',
        status_order_sp_rejected: '',
      },
      statusesShort: {
        status_order_new: 'Nuevo',
        status_order_completed: 'Finalizado',
        status_awaiting_customer_dropoff: 'A depositar',
        status_order_awaiting_collect: 'Esperando recogida',
        status_order_in_route_collect: 'En ruta recoger',
        status_order_sp_collected: 'Recogido y en proceso',
        status_order_in_progress: 'En progreso',
        status_order_assembled: 'Preparado',
        status_order_in_route_delivery: 'En ruta entregar',
        status_order_sp_delivered: 'Entregado',
        // not used at the moment
        status_order_delayed: '',
        status_order_sp_cancelled: '',
        status_order_client_cancelled: 'Cancelado por el cliente',
        status_order_sp_rejected: '',
      },
      items: 'Ítems del pedido',
      status: 'Estado',
      paymentStatus: 'Estado del pago',
      paymentStatuses: {
        status_payment_unpaid: 'Sin pagar',
        status_payment_paid: 'Pagado',
        status_payment_declined: 'Declinado',
        status_payment_unpaid_invoice: 'Factura sin pagar',
        status_payment_paid_invoice: 'Pagado factura',
        notConfirmed: 'Esperando confirmation',
      },
      forceStatus: {
        title: 'Forzar estado manualmente',
        current: 'actual',
        button: 'Actualizar estado',
      },
      admin_collect: {
        button: 'Admin recoge pedido',
        collect: 'Pedido recogido por el administrador',
        label: 'Información sobre la recogida',
        hint: 'Usar esta opcion cuando el cliente nos ha dado pesonalmente el pedido (ropa, etc)',
        min: 'mínimo 10 caracteres',
      },
      types: {
        delivery_with_code: 'Paquetería',
        locker_order: 'Locker order',
        laundry_drop_go: 'Tintorería - dejar y listo',
        public_locker: 'Taquilla publica',
        home_delivery: 'Domicilio',
        office_order: 'Oficina',
        bizcocho_order: 'Bizcocho',
        internal_delivery_1: 'Paquetería interna',
        drop_only: 'Dejar/mantenimiento',
        amazon_return: 'Devoluciones Amazon',
        custom: 'Personalizado',
        unknown: '???',
        smart_drop: 'Smart drop',
        package_transfer: 'Transfer',
        cascos: 'Storage',
        professional_service: 'Servicio profesional',
      },
      orderList: {
        quickFilters: {
          title: 'Filtros rapidos',
          filters: {
            awaiting_delivery: 'Esperando recogida',
            payable: 'Por pagar',
            ready_delivery: 'Listo para entregar',
            without_package: 'Excluir paqueteria',
            future_orders: 'Pedidos futuros',
            rentback: 'Rentback',
            discount_code: 'Código de descuento',
            completed: 'Completados',
            delivered: 'En taquilla',
            in_locker_24h: 'En taquilla +24h',
            in_locker_72h: 'En taquilla +72h',
          },
        },
        csvExportHint: 'Descarga un archivo CSV con los pedidos que coinciden con los filtros actuales. Limitado a 1000 filas. Aplica filtros primero para acotar los resultados.',
        csvLimitTitle: 'Límite de filas alcanzado',
        csvLimitText: 'Estás descargando más de 1000 filas, que es el límite máximo. El archivo CSV estará incompleto y perderás datos. Debes aplicar filtros para acotar la información que necesitas antes de descargar.',
      },
      stats: {
        totalOrders: 'Total de pedidos',
        byDay: 'Día',
        byWeek: 'Semana',
        byMonth: 'Mes',
        noData: 'Sin datos para el período seleccionado',
        today: 'Hoy',
        thisWeek: 'Últ. Sem.',
        thisMonth: 'Este mes',
        last2Months: 'Mostrando últ. 2 meses',
        lastYear: 'Mostrando últ. año',
        thisWeekFull: 'Esta semana',
        thisMonthFull: 'Este mes',
        ordersLabel: 'pedidos',
      },
      dates: {
        active_from: 'Activo desde',
        created_at: 'Fecha de creación',
        due: 'Fecha de vencimiento',
      },
      locker_code: 'Código de taquilla',
      lockerCode: 'Código de taquilla',
      noLockerCode: 'No hay un compartimento/codigo asignado',
      confirmed: {
        label: 'Confirmacion',
        values: {
          0: 'Sin confirmacion',
          1: 'Confirmados',
        },
      },
      created_at: 'Fecha de creación',
      due: 'Fecha de vencimiento',
      sub_total: 'subtotal',
      vat: 'iva',
      grand_total: 'total',
      grandTotal: 'Total',
      delivery_costs: 'Gastos de envio',
      promotion: 'Promocion',
      rentback: 'Rentback',
      pickedUpAt: 'Recogido',
      pendingPickupAgeTags: {
        over24h: '24h+',
        over72h: '72h+',
      },
      rating: {
        title: 'Puntuación',
      },
      details: {
        title: 'Detalles',
        printCTA: 'Imprimir ticket',
        locker: 'Smartpoint',
      },
      print: {
        order: 'Pedido',
        created: 'Creado',
        items: 'Artículos',
        service: 'Servicio',
        qty: 'Cant.',
        price: 'Precio',
        total: 'Total',
        notes: 'Notas',
        print: 'Imprimir',
      },
      location: {
        title: 'Ubicacion',
        types: {
          locker: 'Smartpoint',
        },
        pickupLocation: 'De recogida',
        deliveryLocation: 'De reparto',
      },
      timeslot: {
        pickupTimeslot: 'Plazo de recogida',
        deliveryTimeslot: 'Plazo de reparto',
      },
      user: {
        title: 'Cliente',
      },
      services: {
        title: 'Servicios',
        titleSingular: 'Servicio',
      },
      history: {
        title: 'Historia',
      },
      communications: {
        title: 'Communications',
        contentDialogTitle: 'Mensaje #',
        to: 'Para',
        type: 'Tipo',
        status: 'Estado',
        createdAt: 'Enviado',
        content: 'Contenido',
        silent: 'Sin comunicaciones',
      },
      logs: {
        title: 'Historia',
        actions: {
          101: 'pedido creado (en smartpoint)',
          102: 'pedido creado (paqueteria)',
          103: 'pedido creado',
          104: 'imagen subida',
          106: 'pedido pagado',
          115: 'articulo dejado (cliente)',
          121: 'pedido recogido (proveedor)',
          122: 'pedido entregado',
          145: 'pedido recogido (cliente)',
          146: 'destinato aňadido',
          147: 'transfer a casa',
          150: 'pedido borrado',
          160: 'pedido finalizado',
          161: 'no more communications',
          181: 'pedido valorado (cliente)',
          201: '---',
          300: 'pedido confirmado',
          310: 'pedido confirmado (cliente)',
          330: 'pedido preparado',
          331: 'servicio procesado',
          350: 'nuevo compartimento asignado',
          501: 'confirmacion re-enviado',
          629: 'marcado sin pagar',
          700: 'error de spike',
          100300: 'order de abrir celda enviado para el smartpoint',
        },
        fields: {
          a: 'adminId',
          c: 'charge',
          con: 'confirmed',
          cn: 'comment/note',
          cr: 'reason/note',
          em: 'mensaje de error',
          fp: 'firstPaid',
          lc: 'cellId',
          m: 'method',
          o: 'origin',
          olc: 'old cellId',
          ols: 'old status',
          r: 'rating',
          s: 'status',
          so: 'operacion de spike',
          t: 'total',
          tld: 'destination',
          u: 'userId',
          w: 'reason',
        },
      },
      notes: {
        title: 'Notas',
        fromAdmin: 'Nota de administrador, pulsa el icono para ver quien',
        fromUser: 'Nota del cliente',
        addPlaceholder: 'Escribe una nota...',
        addCTA: 'Guardar nota',
      },
      image: {
        title: 'Imagen asociada'
      },
      pickupCell: 'Recoger de este compartimento',
      deliveryCell: 'Repartir a este compartimento',
      channel_id: 'Canal',
      open_remote_cell: 'Abrir Compartimento',
      // action buttons
      errors: {
        orderNotPaid: 'No se puede finalizar el pedido si no está pagado',
      },
      CTA: {
        delete: {
          button: 'Borrar',
          title: 'Marcar el pedido borrado, reteniendo los datos originales',
        },
        finalize: {
          button: 'Marcar completo',
          title: 'Finalizar pedido, saltando cualquier paso pendiente.',
        },
        confirm_professional_service: {
          button: 'Confirmar Profesional',
          title: '¿Quieres confirmar al profesional para este pedido?',
        },
        newLockerCell: {
          button: 'Nuevo compartimento',
          errorTitle: 'Falta asignar un compartimento a este pedido manualmente.',
          title: 'Asignar nuevo compartimento',
          noLockerNoCell: 'Este pedido no tiene locker, no es posible asignar compartimento.',
        },
        pay: {
          button: 'Marcar pagado',
          title: 'Marcar el pedido pagado.',
        },
        requestPickup: {
          button: 'Por pagar y esperando recogida',
          title: 'Asignar compartimento y notificar al cliente que el pedido está pendiente de pago y de recogida',
        },
        repeat: {
          button: 'Repetir',
          title: 'Repetir pedido una vez, o periodicamente',
          dialogTitle: 'Repetir pedido',
          firstDate: 'Primera fecha',
          frequency: 'Frecuencia',
          cnt: 'Número de repeticiones',
          success: 'Pedidos creados:',
          frequencies: {
            week: 'Semanal',
          },
        },
        resendConfirmation: {
          button: 'Enviar nuevo confirmacion',
        },
        unPay: {
          button: 'Marcar no pagado',
          title: 'Marcar pedido "sin pagar", y borrar anterior pago efectivo (si hay)',
        },
        openCell: {
          button: 'Abrir compartimento',
          title: 'Confirma para abrir el compartimento'
        },
        silence: {
          button: 'Silenciar',
          title: 'Marcar pedido silencioso. No se enviaran comunicaciones sobre este pedido. Este operacion no se puede anular.',
        },
      },
    professional_service: {
        price_section_title: 'Precio',
        fields: {
          unit_type: 'Tipo de unidad',
          unit_amount: 'Cantidad de unidad',
          unit_price: 'Precio de unidad',
        },
        one_time: 'Una vez',
        daily: 'Diario',
        weekly: 'Semanal',
        biweekly: 'Quincenal',
        monthly: 'Mensual',
        calculation_units: {
          hours: 'Horas',
          days: 'Días',
          m2: 'm²',
          rooms: 'Habitaciones',
          units: 'Unidades',
          people: 'Personas',
        },
        service_details_section: {
          title: 'Detalles del servicio',
          fields: {
            subscription: 'Suscripción',
            starting_date: 'Fecha de inicio',
            starting_hour: 'Hora de inicio',
            chosen_days: 'Días elegidos',
            cancellation_date: 'Fecha de cancelación',
            cancellation_time: 'Hora de cancelación',
            cancellation_reason: 'Razón de cancelación',
            cancellation_text: 'Texto de cancelación',
            refund_percentage: 'Porcentaje de reembolso',
            refund_amount: 'Cantidad de reembolso',
            cancellation_reasons: {
              'unexpected_emergency': 'Emergencia inesperada',
              'no_longer_needed': 'Ya no lo necesito',
              'another_provider': 'Elegí otro proveedor',
              'other': 'Otro',
            },
            time_format: 'HH:MM',
            date_format: 'DD/MM/YYYY',
            date_future: 'La fecha debe ser futura',
            date_required: 'La fecha es requerida',
            time_required: 'La hora es requerida',
            date_future_maximum: 'La fecha debe ser futura, y no más de 2 meses en el futuro',
          },
        },
      },
    },
    promotion: {
      promo_code: 'Promo code',
      type: 'Type',
      value: 'Value',
      value_type: 'Value type',
      min_total: 'Minimum total of order',
      active: 'Disponible',
      types: {
        first_order: 'Primer pedido',
        one_time: 'Una vez',
        multiple_times: 'Varias veces',
      },
      valueTypes: {
        absolute: 'Total',
        percentage: 'Porcentaje',
      },
      origins: {
        mgm: 'Member get member',
        personal: 'Cupon personal',
        other: 'Promocion publico',
      },
    },
    package_delivery: {
      title: 'Paquete para',
      cell: 'Compartimento',
      open_remote_cell: 'Abrir compartimento remoto',
      courier: 'Transportista',
    },
    search: {
      title: 'Buscar pedidos',
      hint: 'Id del pedid, nombre de usuario, nombre o direccion de Smart Point',
    },
    services: {
      processed: 'Procesado',
      name: 'Que',
      quantity: 'Cantidad',
      sub_total: 'Precio',
      add: 'Aňadir servicio',
      noItems: 'Sin servicios.',
      confirmed: 'Pedido confirmado — los artículos no se pueden editar.',
      deleteConfirm: '¿Eliminar este servicio del pedido?',
      addPriceHint: 'Dejar en blanco para usar el precio por defecto',
      CTA: {
        assemble: {
          button: 'Pedido preparado',
        },
        confirm: {
          button: 'Confirmar',
          title: 'Confirmar servicios y enviar nota de pago',
        },
        edit: {
          button: 'Actualizar servicios',
          title: 'Agregar o borrar servicios',
        },
        add: {
          button: 'Añadir servicio',
        },
        releaseCell: {
          button: 'Liberar celda',
        },
        newCode: {
          button: 'Nuevo código',
        },
      },
    },
  },
  lockerCompanies: {
    createDialog: {
      title: "Crear compañia",
      slug: "Slug",
      description: "Descripción",
    },
    errors: {
      image: {
        'exactWidth:330': 'El tamaňo del imagen no es 330*110',
        'exactHeight:110': 'El tamaňo del imagen no es 330*110',
      },
    },
    fields: {
      description: 'Empresa',
      image: "Logo",
    },
    logs: {
      actions: {
        100: 'empresa creado',
        110: 'empresa/landing aňadido',
        111: 'empresa/landing eliminado',
      },
      headers: {
        company: 'Empresa',
      },
    }
  },
  realtime: {
    smallTalk: 'the big number is orders today so far, the 3 under: orders on past days up to same hour of day',
    smallTalkCont: 'excluye pedidos de Smart Points y proveedores internos',
    smallTalk2: 'total de Smart Points activos y usuarios',
    lastMonth: 'MOM',
    lastYear: 'YOY',
    lastWeek: 'WOW',
    onlineLockers: 'Smart Points',
    target: 'objetivo',
    title: 'Información en tiempo real',
  },
  screen_savers: {
    title_locker: 'Salvapantallas en SmartPoint',
    title_in_locker: 'en SmartPoint',
    title: 'Salvapantallas',
    logs: {
      title: "Logs de los salvapantallas",
      singleSsTitle: "Logs del salvapantallas",
      actions: {
        100: 'crear Salvapantalla',
        200: 'copiar Salvapantalla',
        300: 'conectar/desconectar',
        500: 'activar/desactivar',
        700: 'borrar salvapantalla',
      },
      orderType: 'Tipo de orden',
      commissionRate: 'Comisión (%)',
      commissionType: 'Tipo de comisión',
    },
    edit: {
      title: 'Editar salvapantallas',
      createTitle: 'Crear salvapantallas',
      errors: {
        missingRequiredFields: 'Debes completar estos campos obligatorios',
        nameRequired: 'El nombre es obligatorio',
        fieldRequiredSuffix: ' es obligatorio',
        imageRequired: 'Debes subir una imagen',
        serviceProviderRequired: 'Debes seleccionar un proveedor de servicio',
      },
    },
  },
  serviceProvider: {
    metrics: {
      title: 'Métricas Mensuales',
      scopeSize: 'Alcance (Usuarios)',
      visit: 'Visita',
      purchaseIntent: 'Intención de compra',
      orders: 'Pedidos',
      gmv: 'GMV (€)',
      commission: 'Comisión',
      commissionValue: 'Valor comisión (€)',
      closeMonth: 'Cerrar Mes',
      goToActivePeriod: 'Ir al período activo',
      monthClosedOK: 'Período cerrado correctamente',
      periodOpen: 'Abierto',
      periodClosed: 'Cerrado',
      periodNotClosed: 'No cerrado',
      periodPreview: 'Preview',
      readOnly: 'Solo lectura',
      estimate: 'Cant. estimada',
      enterValue: 'Introducir valor',
      incompleteWarning: '{count} proveedores con datos incompletos',
      confirmClose: {
        title: 'Cerrar Mes',
        text: 'Esto bloqueará todos los datos del período seleccionado. Esta acción no se puede deshacer.',
        confirm: 'Cerrar Período',
      },
      orderTypes: {
        automatic: 'Automático',
        b2b_account: 'Cuenta B2B',
        partner_feedback: 'Feedback de Partner',
        estimate: 'Estimado',
      },
      commissionTypes: {
        real: 'Real',
        estimated: 'Estimada',
        manual: 'Manual',
      },
      saveValidationError: 'Debes rellenar todos los campos obligatorios antes de guardar.',
      statusComplete: 'Completo',
      statusAwaitingValidation: 'Pendiente de Validación',
      statusPending: 'Sin actividad',
      statusIncomplete: 'Incompleto',
      closedMonthsOnly: 'Solo tienes acceso a meses cerrados. Navega a un período cerrado para ver los datos.',
      previousMonthData: 'Datos del mes anterior',
    },
  },
  standalones: {
    createDialog: {
      title: 'Crear un portal digital',
      text: 'Se va a crear un nuevo portal digital dentro de este locker, con un código de instalación para vincularlo al dispositivo físico.',
      error: 'Ha habido un error al crear el portal digital',
      type: 'Tipo de dispositivo',
    },
  },
  services: {
    provider: {
      nav: {
        details: 'Detalles',
        services: 'Servicios',
        products: 'Productos',
        promotions: 'Promociones',
        lockers: 'En comunidades',
      },
      active: {
        confirmEnable: 'Habilita el proveedor en todos los Smart Points',
        confirmDisable: 'Deshabilita el proveedor en todos los Smart Points',
      },
      duplicate: {
        title: 'Duplicar, crear una copia del proveedor',
        text: '¿Estas seguro que quieres duplicar este proveedor?',
        description: 'Copia los datos a un proveedor nuevo',
        help: 'Esta opcion te permite copiar este proveedor de servicios. Dupicará todos los datos, incluyendo sus' +
          ' servicios. nota: no copiara imagenes, extensiones ni permisos de usuarios',
        spLoadingError: 'Error cargando los datos del proveedor',
        spDuplicationOk: 'El proveedor de servicios ha sido duplicado correctamente',
        buttonGo: 'Ir al Proveedor de servicio duplicado',
      },
      delete: {
        confirm: '¿Estás seguro de que quieres eliminar este proveedor de servicios? Esta acción no se puede deshacer si no hay pedidos abiertos.',
        errorOpenOrders: 'Este proveedor de servicios tiene pedidos abiertos y no se puede eliminar.',
      },
      categories: {
        title: 'Categorias',
        values: {
          10: 'paqueteria (OLD)',
          20: 'comidas (OLD)',
          30: 'platos del dia (OLD)',
          40: 'tiendas (OLD)',
          50: 'click-n-collect (OLD)',
          60: 'recados (OLD)',
          70: 'one-click (OLD)',
          80: 'servicios edificios (OLD)',
          110: 'Mi edificio (OLD)',
          120: 'Servicios para Mi (OLD)',
          130: 'Tiendas y Regalos (OLD)',
          140: 'Pets (OLD)',
          150: 'Comida (OLD)',
          160: 'Experiencias (OLD)',
          170: 'Salud (OLD)',
          210: 'Mi edificio',
          220: 'Movilidad',
          230: 'Peques',
          240: 'Mascotas',
          250: 'Comida',
          260: 'Economía circular',
          270: 'Asistencia',
          280: 'Paquetería',
          290: 'Lifestyle',
          300: 'Corporación',
        },
        noCategories: 'Sin categoria el proveedor no aparece correctamente en el app',
      },
      channels: {
        noChannel: 'Se requiere al menos un canal',
      },
      errors: {
        image: {
          'maxWidth:1900': 'Max width 1900px',
          'maxHeight:1425': 'Max height 1425px',
          'maxImageSize:614400': 'Maximum 600kb',
        },
      },
      professional_service_fields: "Configuración del servicio profesional",
      professional_card: {
        subtitle: 'Precio, disponibilidad y lo que incluye el servicio',
        pricing_title: 'Precio',
        pricing_desc: 'Lo que paga el cliente y cómo se mide el servicio',
        availability_title: 'Disponibilidad',
        availability_desc: 'Cuándo puede reservar el cliente. Si dejas un campo vacío, se usa el valor por defecto.',
        scope_title: 'Qué incluye',
        scope_desc: 'Se muestra al cliente antes de reservar',
        working_days: 'Días de trabajo',
        no_working_days: 'No hay días de trabajo seleccionados. Los clientes no podrán reservar este servicio.',
        lead_days: 'Antelación mínima',
        lead_days_hint: 'Días desde hoy hasta el primer día reservable, que empieza a la hora de apertura',
        max_days: 'Ventana de reserva',
        max_days_hint: 'Con cuántos días de antelación se puede reservar como máximo',
        opening_hour: 'Hora de apertura',
        closing_hour: 'Hora de cierre',
        slot_minutes: 'Franjas',
        days_suffix: 'días',
        minutes_suffix: 'min',
        default_value: '{value} (por defecto)',
        summary: 'Se puede reservar desde hoy + {leadDays} días a las {opening}, hasta {maxDays} días vista. Las horas de inicio van de {opening} a {closing}, cada {slot} min, en días de trabajo.',
        errors: {
          lead_days: 'Entre 1 y 30 días, y menos que la ventana de reserva',
          max_days: 'Entre 2 y 365 días, y más que la antelación mínima',
          opening_hour: 'Debe ser anterior a la hora de cierre',
          closing_hour: 'Debe ser posterior a la hora de apertura',
          slot_minutes: 'Elige 15, 20, 30 o 60 minutos',
        },
      },
      noIncludesOrExcludes: 'Please write what the service includes and excludes',
      scope: {
        title: 'Alcance',
        hint: 'Define las zonas donde prestará servicio este proveedor. Es independiente de la dirección de la oficina.',
        country: 'País',
        countryRequired: 'El país del alcance es obligatorio',
        cities: 'Ciudades',
        zipcodes: 'Códigos postales',
        verticals: 'Verticales',
        selectCountryFirst: 'Selecciona primero un país de alcance',
        invalidZipcode: 'Código postal inválido para el país seleccionado',
        filterExplanation: 'Esta configuración se usa para los filtros de búsqueda y de asignación. Si no tiene nada asignado, aparecerá en todas las zonas y/o verticales.',
      },
      fields: {
        howToTitle: 'Pasos para usar el servicio',
        instructions_1: 'Paso 1',
        instructions_2: 'Paso 2',
        instructions_3: 'Paso 3',
        hide_app_interface: "Esconde interface en el app",
        urgency_tag: "Texto etiqueta de incentivos",
        urgency_tag_hint: "Si una opcion de la etiqueta de incentivos ha sido seleccionada, este texto sera usado en la etiqueta",
        infocard_cta_text: 'Texto del boton CTA (dejar vacio para usar el valor por defecto)',
        about_us: 'Descripcion',
        address_line_2: '(continuacion)',
        address_postcode: 'Post code',
        address_town_city: 'Ciudad',
        address_county: 'Provincia',
        address_country_id: 'Pais',
        autoconfirm: 'Auto-confirmacion',
        delivery_address: 'Direccion de entrega',
        display_locker: 'Mostrar en lockers',
        display_locker_or_digital_portal: 'Mostrar en lockers / Portal Digital',
        suscription_status: 'Suscripción',
        subscription_card_title: 'Suscripciones',
        subscription_card_subtitle: 'Configuración de suscripción en Stripe',
        subscription_card_inactive: 'Inactivo',
        subscription_advanced_config: 'Configuración avanzada de suscripción',
        billing_anchor_section: 'Ciclo de facturación',
        billing_anchor_section_desc: 'Día fijo de cobro y ventana de corte opcional',
        billing_anchor_day: 'Día de cobro (1–28)',
        billing_anchor_day_hint: 'Sin configurar: cobro inmediato al suscribirse',
        billing_cutoff_day: 'Día de corte (1–28, opcional)',
        billing_cutoff_day_hint: 'Suscripción tardía aplaza el primer cobro según los ciclos configurados',
        billing_cycles_after_cutoff: 'Ciclos de espera tras el corte',
        billing_cycles_after_cutoff_hint: 'Meses desde el anchor de este mes hasta el primer cobro (por defecto: 2)',
        billing_anchor_preview: 'Primer cobro si se suscribe hoy',
        subscription_trial_section: 'Periodo de prueba',
        subscription_trial_section_desc: 'Acceso gratuito antes del primer cobro',
        subscription_trial_days: 'Días de prueba gratuita',
        subscription_trial_days_hint: 'Estado "trialing" en Stripe — sin cobro hasta que acaba',
        subscription_trial_end_behavior: 'Al terminar la prueba sin tarjeta',
        subscription_trial_end_behavior_hint: 'Solo si el cliente no tiene tarjeta guardada al acabar',
        subscription_trial_end_behavior_values: {
          cancel: 'Cancelar la suscripción',
          pause: 'Pausar la suscripción',
          create_invoice: 'Generar factura y esperar pago',
        },
        subscription_billing_section: 'Cobro y prorrateo',
        subscription_billing_section_desc: 'Prorrateo, método de cobro y configuración avanzada',
        subscription_proration_behavior: 'Comportamiento de prorrateo',
        subscription_proration_behavior_hint: 'Periodo entre la suscripción y el primer día de cobro',
        subscription_proration_behavior_values: {
          none: 'Sin cargo hasta el día de cobro',
          create_prorations: 'Cobrar proporcional al periodo de acceso',
        },
        subscription_collection_method: 'Método de cobro',
        subscription_collection_method_hint: 'Aplicable en renovaciones manuales desde el backoffice',
        subscription_collection_method_values: {
          charge_automatically: 'Cobro automático con tarjeta',
          send_invoice: 'Enviar factura al cliente',
        },
        subscription_days_until_due: 'Días para pagar la factura',
        subscription_days_until_due_hint: 'Días antes de que la factura se marque como vencida',
        subscription_payment_behavior: 'Si falla el primer cobro',
        subscription_payment_behavior_hint: 'Solo en renovaciones manuales — en checkout lo gestiona Stripe',
        subscription_payment_behavior_values: {
          default_incomplete: 'Incompleta — 23h de ventana para pagar',
          error_if_incomplete: 'Error — rechaza la creación',
          allow_incomplete: 'Permisiva — activa aunque falle',
        },
        subscription_automatic_tax: 'Impuestos automáticos (Stripe Tax)',
        subscription_automatic_tax_hint: 'Requiere Stripe Tax configurado en el dashboard de Stripe',
        stripe_discount_section: 'Descuento en Stripe',
        stripe_discount_section_desc: 'Se aplica automáticamente en cada pago único con Stripe',
        stripe_discount_none: 'Sin descuento',
        stripe_discount_note: 'En el checkout de Stripe el cliente ve el precio original, el descuento y el total final. No se aplica a suscripciones.',
        stripe_discount_type: 'Tipo de descuento',
        stripe_discount_type_hint: 'Déjalo vacío para cobrar el precio completo',
        stripe_discount_type_values: {
          fixed: 'Importe fijo (€)',
          percentage: 'Porcentaje (%)',
        },
        stripe_discount_value: 'Descuento',
        stripe_discount_value_hint: 'Si el descuento cubre todo el pedido, el pedido es gratis y no pasa por Stripe',
        stripe_discount_example: 'Ejemplo: en un pedido de {price} el cliente paga {total} (descuento -{discount})',
        stripe_discount_example_free: 'Ejemplo: un pedido de {price} queda cubierto entero, así que es gratis y no pasa por Stripe',
        service_price: "Precio del Servicio",
        calculation_unit: "Unidad de Cálculo",
        calculation_unit_types: {
          hours: "Horas",
          days: "Días",
          m2: "Metros cuadrados",
          rooms: "Habitaciones",
          units: "Unidades",
          people: "Personas"
        },
        range_min: "Rango Mínimo",
        range_max: "Rango Máximo",
        range: "Rango",
        days_available: "Días Disponibles",
        days_available_hint: "Número de días al año que el servicio está disponible",
        service_includes: "Servicio Incluye",
        service_includes_hint: "Descripción de lo que incluye el servicio",
        service_excludes: "Servicio Excluye",
        service_excludes_hint: "Descripción de lo que no incluye el servicio",
        days_of_week: {
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        has_item_tracking: 'Seguimiento de articulos',
        invoicing_address: {
          title: 'Direccion de facturacion',
          noAddress: 'Por favor escribe una direccion'
        },
        link: {
          professional_title: 'Enlace para presupuestos o información profesional',
          title: 'Enlace externo',
          titleWebviev: 'Enlace Webview',
          hint_qr_bizcocho: 'Cuantas veces se usaron el enlace en el webapp',
          hint_qr_locker: 'Cuantas veces se han leido el QR en un Smart Point',
        },
        link_note: 'Este enlace sólo se muestra en la aplicación web, no en el locker',
        link_note_webview: 'Este enlace es el webview visible',
        phone_for_queries: {
          title: 'Teléfono para iniciar órdenes, pedir presupuestos o hacer preguntas de un servicio'
        },
        phone_for_queries_note: 'Se muestra en un banner dentro de la info card. Si el campo esta vacio, no se mostrará el banner.',
        name: 'Nombre (uso internal, unico)',
        order_instructions: 'Instrucciones',
        payment_provider: 'Payment provider',
        phone_number: 'Numero telefono',
        phone_number_mobile: 'Numero movil',
        primary_service_description: 'Nombre (para apps/clientes)',
        send_communications: 'Enviar mensajes',
        tax_id_number: 'CIF',
        tax_percentage: 'IVA',
        uploads_enabled: {
          label: 'Cargar etiqueta',
          hint: 'Si habilitado, se le pedirá al usuario subir la etiqueta de envío',
        },
        precheck_url: 'URL de precheck',
        purchase_url: 'URL de compra',
        link_tracking: {
          section: 'Tracking del enlace',
          section_desc: 'Identificadores que se añaden al enlace al abrirlo, para que el partner atribuya las conversiones',
          preset: 'Destino',
          preset_hint: 'Quién recibe los identificadores y con qué nombre de parámetro',
          presets: {
            none: 'Ninguno',
            impact: 'Impact (subId1 / subId2)',
            integrations_platform: 'Integrations Platform (u / c)',
            custom: 'Personalizado',
          },
          user: 'Parámetro para el ID de usuario',
          user_hint: 'Vacío: no se envía el ID de usuario',
          community: 'Parámetro para el ID de comunidad',
          community_hint: 'Vacío: no se envía el ID de comunidad',
          preview_app: 'App',
          preview_standalone: 'Standalone',
          note: 'Se aplica al enlace del webview o de la infocard. La app envía el usuario y la comunidad; los standalones solo la comunidad, porque no tienen usuario.',
          developers_only: 'Solo los developers pueden cambiar el link tracking.',
        },
        integration_data: {
          label: 'Datos de integración (objeto JSON)',
          hint: 'Ejemplo: {"key": "value"}',
          invalid_json: 'Los datos de integración deben ser un objeto JSON válido',
        },
        limited_to: {
          label: 'Limitado a comunidades',
          hint: 'Selecciona una o varias comunidades',
        },
        use_only_restricted_cells: 'Usar solo celdas restringidas',
        website: 'Sitio web',
        extensions: {
          values: {
            'request-callbacks': 'Solicitar llamada',
            'contact-and-questions': 'Contacto/preguntas general',
            'custom-order': 'Pedido libre en lista de servicios',
            'drop-and-go': 'Drop & go disponible',
            // 'qr-codes': 'qr-codes',
            'quick-notes-urgent': 'Notas rápidas: urgente',
            'quick-notes-request-quote': 'Notas rápidas: solicitar presupuesto',
            'quick-notes-callback': 'Notas rápidas: llámame',
            // '24h': '24h',
          },
        },
        status: {
          label: 'Estado',
          values: {
            '': '-',
            'new': 'new',
            'business': 'business',
            'flash': 'flash',
            'limited_edition': 'limited edition',
            '50pcnt': '50%',
            'exclusive': 'exclusive',
            'monday': 'lunes',
            'tuesday': 'martes',
            'wednesday': 'miercoles',
            'thursday': 'jueves',
            'friday': 'viernes',
          },
        },
        channel: {
          label: 'Canal',
          hint: 'El canal define el método de pago y la divisa del proveedor de servicio.',
        },
        urgency_tag_type: {
          label: 'Etiqueta de incentivos',
          explanation: 'Este campo muestra señales de incentivo como: Descuentos (Ahorro), Últimas unidades (Escasez), Tiempo limitado (Urgencia), Buenas reseñas (Prueba social), Envío gratis (Menos fricción), Nuevo (Curiosidad)',
          values: {
            [E_SERVICE_PROVIDER_TAG_TYPES.NO_TAG]: '-',
            [E_SERVICE_PROVIDER_TAG_TYPES.DISCOUNT_PERCENTAGE]: 'Descuento',
          },
        },
        type: {
          label: 'Tipo',
          values: {
            amazon_return: 'Devoluciones (amazon)',
            drop_only: 'Drop/mantenimiento',
            home_delivery: 'Entrega a casa',
            infocard: 'Infocard',
            infocard_sending: 'Infocard_enviado',
            offline: 'offline',
            open_order: 'Pedido abierto',
            services: 'Servicios',
            supermarket: 'Supermercado',
            smart_drop: 'Smart drop',
            smart_storage: 'Smart storage',
            professional_services: 'Servicios Profesionales',
            webview: 'Webview',
          },
        },
        logo_image: {
          title: 'Logo',
          subtitle: 'para el locker y por defecto el app',
          noImage: 'El logo es necesario',
        },
        second_image: {
          title: 'Animacion',
          subtitle: 'animacion para el app index',
        },
        brand_image: {
          title: 'Imagen de marca',
          subtitle: 'substituye logo en el app',
          noImage: 'La imagen de marca es necesaria',
        },
      },
      invoicing: {
        title: 'Facturacion',
        noAddress: 'Se requiere la direccion para facturar',
      },
      lockers: {
        title: 'En Smartpoints',
        description: 'En cual Smartpoints es disponible este proveedor?',
      },
      noDescription: 'Por favor escribe un nombre y descripcion para todos los idiomas',
      onImageZoom: 'en breve, mientras, click derecha en la imagen y abrir en nueva pestaňa',
      promotions: {
        title: 'Promociones',
        description: 'De promociones, haz feliz a alguien',
        add: 'Añadir Promoción',
        edit: 'Editar Promoción',
        delete: {
          confirm: '¿Estás seguro de que quieres eliminar esta promoción?',
        },
        fields: {
          promo_code: 'Código promocional',
          value: 'Valor',
          value_type: 'Tipo de valor',
          expiration_date: 'Fecha de expiración',
          min_total: 'Total mínimo',
          notes: 'Notas',
          display_app: 'Mostrar en app',
        },
      },
      search: 'Buscar en nombre, tipo, ubicacion',
      settings: 'Ajustes',
      serviceProvidersCategories: {
        title: 'Proveedores en categoria',
        CTA_assign: 'asignar',
        CTA_order: 'ordenar',
      },
      serviceProvidersServices: {
        title: 'Servicios de proveedor:',
      },
      services: {
        title: 'Servicios del proveedor',
        description: 'Manejar los servicios',
      },
      users: {
        operator: 'operador',
        owner: 'dueňo',
      },
      where: '¿On which Smart Points is this provider available?',
      which: '¿Cual proveedores estan disponible en este Smart Point?',
      whichCommunity: '¿Qué proveedores están disponibles en esta comunidad?',
    },
    services: {
      create: {
        title: 'Crear Servicio',
      },
      edit: {
        title: 'Editar Servicio',
      },
      delete: {
        confirm: '¿Estás seguro de que quieres eliminar este servicio? Esta acción no se puede deshacer.',
      },
      sections: {
        labels: 'Etiquetas',
        pricingAndDetails: 'Precios y detalles',
        tags: 'Tags',
        images: 'Imágenes',
      },
      fields: {
        minimum_locker_cell_size_id: {
          label: 'Tamaño mínimo del compartimento',
        },
        sale_price: {
          label: 'Precio en oferta',
        },
        on_sale: {
          label: 'En promoción',
        },
        turnaround_time: {
          label: 'Plazo estimado',
        },
        short_description: {
          label: 'Descripción corta',
        },
        description: {
          label: 'Descripción',
        },
        mandatory: {
          label: 'Coste de entrega',
        },
        orderby: {
          label: 'Orden',
        },
        tickets: {
          label: 'Tickets',
        },
        active: {
          label: "¿El servicio está actualmente disponible en las taquillas?",
        },
        tags: {
          label: 'Tags',
        },
        logo_file: {
          title: 'Logo',
          subtitle: 'Imagen principal del servicio',
          noImage: 'El logo es necesario',
        },
        second_logo: {
          title: 'Segunda imagen',
          subtitle: 'Imagen secundaria del servicio',
        },
      },
      errors: {
        image: {
          'maxWidth:1900': 'Ancho máximo 1900px',
          'maxHeight:1425': 'Alto máximo 1425px',
          'maxImageSize:614400': 'Máximo 600kb',
        },
      },
    },
  },
  modules: {
    intro: 'Los módulos son las funciones que una comunidad puede activar. Los submódulos son lo que una comunidad elige dentro de un módulo, como su tipo de integración.',
    create: 'Nuevo módulo',
    createTitle: 'Nuevo módulo',
    editTitle: 'Editar módulo',
    edit: 'Editar',
    save: 'Guardar módulo',
    saveFailed: 'El módulo no se ha guardado. Revisa los campos y vuelve a intentarlo.',
    empty: 'Aún no hay módulos. Crea el primero para ofrecerlo a las comunidades.',
    communitiesCount: 'Ninguna comunidad | 1 comunidad | {count} comunidades',
    communities: 'Comunidades',
    communitiesHelp: 'Comunidades que tienen este módulo activado, con el submódulo que eligió cada una. El módulo se activa o desactiva en la página Editar de cada comunidad.',
    searchCommunities: 'Buscar comunidades',
    noCommunityMatches: 'Ninguna comunidad coincide con la búsqueda.',
    noCommunities: 'Ninguna comunidad tiene este módulo activado todavía.',
    noPick: 'Sin elegir',
    fields: {
      name: 'Nombre',
      icon: 'Icono',
      iconHint: 'Se muestra en la pestaña del módulo en cada comunidad',
      changeIcon: 'Cambiar icono',
      hideIcons: 'Ocultar iconos',
      description: 'Descripción',
      slugHint: 'El identificador se crea a partir del nombre y no se puede cambiar después',
      slugFixed: 'Identificador: {slug} (no se puede cambiar)',
    },
  },

  submodules: {
    title: 'Submódulos',
    help: 'Lo que una comunidad puede elegir en la pestaña de este módulo. Solo se guarda como referencia.',
    add: 'Añadir submódulo',
    save: 'Guardar submódulo',
    editNamed: 'Editar el submódulo {name}',
    empty: 'Aún no hay submódulos, así que las comunidades no tienen nada que elegir en este módulo.',
    pickedBy: 'Sin elegir todavía | Elegido por 1 comunidad | Elegido por {count} comunidades',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
    },
  },

  settings: {
    couriers: {
      tabs: {
        couriers: 'Transportistas',
        catalog: 'Catálogo por país',
      },
      fields: {
        name: 'Nombre',
        code: 'Código',
        codeHint: 'Identificador único en snake_case, p. ej. correos_express',
        codeInvalid: 'Usa solo minúsculas, números y guiones bajos (snake_case).',
        logo: 'Logo',
        logoHint: 'Recomendado: 160px de ancho x 80px de alto, 20px de radio de esquina',
        logoAfterCreate: 'Guarda primero el transportista y después podrás subir su logo.',
        countries: 'Países',
      },
      create: {
        title: 'Nuevo transportista',
      },
      edit: {
        title: 'Editar transportista',
      },
      delete: {
        title: 'Eliminar transportista',
        description: 'El transportista "{name}" se eliminará y se quitará de los catálogos de todos los países.',
      },
      catalog: {
        country: 'País',
        selectCountry: 'Selecciona un país para gestionar sus transportistas.',
        addCourier: 'Transportista a añadir',
        add: 'Añadir',
        noCouriersToAdd: 'Todos los transportistas ya están en este país',
        courierInactive: 'Transportista inactivo',
        moveUp: 'Subir',
        moveDown: 'Bajar',
        remove: {
          title: 'Quitar transportista del país',
          description: '¿Quitar "{name}" del catálogo de {country}?',
        },
      },
      toastSaved: 'Transportista guardado',
      toastDeleted: 'Transportista eliminado',
      errors: {
        code: {
          unique: 'Este código ya lo usa otro transportista.',
          regex: 'Usa solo minúsculas, números y guiones bajos (snake_case).',
        },
        courier_id: {
          unique: 'Este transportista ya está en este país.',
        },
      },
    },
    messages: {
      name: 'Tipo de mensaje',
      channel: 'Canal',
      loadError: 'No se pudieron cargar los mensajes',
      previewError: 'No se pudo cargar la vista previa',
    },
    translations: {
      filter: 'Filtro',
      incomplete: 'Solo incompletas',
      key: 'Clave',
      group: 'Grupo',
      item: 'Item',
      createTitle: 'Crear traduccion',
    },
    permissions: {
      title: 'Mapa de permisos',
      codes: {
        0: 'No permission',
        1: 'Con permiso',
        2: 'Solo del mismo canal',
        3: 'Solo en desarrollo',
      },
      global: 'Global',
      permissions: {
        '1': {
          title: 'Permisos de usuarios',
          description: 'Puede asignar y revocar permisos de los usuarios. Actualizar mapping de permisos.',
          targetLabel: 'Para dar permiso:',
        },
        '2': {
          title: 'Installer',
          description: 'Personas encargado de instalaciones/mantenimiento',
        },
        '3': {
          title: 'Abrir celdas en remoto',
          description: 'Solo con este permiso en particular es posible abrir compartimentos en remoto. SOLAMENTE para action lockers/openCell',
        },
        '4': {
          title: 'Desarrollador',
          description: 'Los del tech',
        },
        '10': {
          title: 'Administrador de sistema',
          description: 'Administrador',
        },
        '11': {
          title: 'Administrador de ajustes',
          description: 'Administrador de ajustes de la sistema',
        },
        '101': {
          title: 'Proprietario de SmartPoint',
          description: 'Proprietario de SmartPoint',
        },
        '102': {
          title: 'Operador de SmartPoint',
          description: 'Operador de SmartPoint',
        },
        '109': {
          title: 'Instalador de fabrica',
          description: 'Instalador de fabrica',
        },
        '110': {
          title: 'Repartidor internal',
          description: 'Repartidor internal',
        },
        '120': {
          title: 'Administrador finanzas',
          description: 'Ver y editar finanzas de los Smart Points',
        },
        '201': {
          title: 'Administrador de canal',
          description: 'Administrador de canal',
        },
        '301': {
          title: 'Proprietario de proveedor',
          description: 'Proprietario de proveedor',
        },
        '302': {
          title: 'Operador de proveedor',
          description: 'Operador de proveedor',
        },
        '400': {
          title: 'Recepcionista de la empresa de casilleros',
          description: 'Recepcionista de la empresa de casilleros',
        },
        '500': {
          title: 'User import',
          description: 'Mass import desde archivo CSV',
        },
        '501': {
          title: 'Difusion express',
          description: 'Max difusion desde archivo CSV',
        },
        '520': {
          title: 'Permiso de Dashboard',
          description: 'Acceso al Dashboard',
        },
        '600': {
          title: 'Order Webhook',
          description: 'Recibir notificaciones sobre pedidos mediante el webhook',
        },
        '601': {
          title: 'User Webhook',
          description: 'Recibir notificaciones sobre usuarios (clientes) mediante el webhook',
        },
        '901': {
          title: 'Conductor OBS',
          description: 'Conductor OBS',
        },
        '902': {
          title: 'Conductor de Smart Point',
          description: 'Conductor con permisos a unos Smart Points',
        },
        '903': {
          title: 'Conductor de canal',
          description: 'Conductor con permisos a un canal entero',
        },
        '904': {
          title: 'Conductor',
          description: 'Conductor con acceso de solo lectura a sus rutas',
        },
        '1001': {
          title: 'API/G1',
          description: 'API/G1 para registrar/login usuarios',
        },
        '701': {
          title: 'Marketing',
          description: 'Rol de Marketing - acceso a gestión de promociones y proveedores',
        },
        '702': {
          title: 'Producto',
          description: 'Rol de Producto - acceso a gestión de promociones y proveedores',
        },
        '703': {
          title: 'Operations',
          description: 'Rol de Operations - acceso a gestión de communities',
        },
        '1550': {
          title: 'API/H1',
          description: 'API to login usuarios (hormiguero)',
        },
      },
    },
    zones: {
      zone: 'Zona',
      create: {
        titlePopUp: 'Crear zona',
        label: 'Nombre de zona nueva',
      },
      findByZone: 'Buscar por zona...',
      findZone: 'Busca zona',
      lockersInZone: 'Lockers in this zone',
      restrictions: {
        title: 'Repartos',
        dayOfWeek: 'Dia',
        hour: 'Hora',
        types: {
          124: 'Reparto diario',
        },
      }
    }
  },
  sshconnections:{
    title: 'Conexiones SSH',
    list:{
        deviceId: 'ID dispositivo',
        vps_ip: 'IP Servidor',
        vps_port: 'Puerto Servidor',
        tunnel_port: 'Puerto Tunel',
        connectionstring: 'Cadena de conexión SSH',
        copysshconnectionstring: 'Copiar SSH cadena de conexión SSH al portapapeles',
    }
  },
  identityIntegrations: {
    title: 'Integraciones de identidad',
    subtitle: 'Proveedores de identidad externos (SAML y OpenID Connect) que pueden autenticar usuarios en Smart Point',
    empty: 'Todavía no hay integraciones de identidad',
    emptyFiltered: 'Ninguna integración coincide con estos filtros',
    saved: 'Cambios guardados',
    readOnly: 'Solo lectura',
    notFound: 'Esta integración de identidad no existe',
    backToList: 'Volver al listado',
    filters: {
      search: 'Buscar',
      searchPlaceholder: 'Nombre, slug o issuer',
      clear: 'Quitar filtros',
    },
    status: {
      active: 'Activa',
      inactive: 'Inactiva',
    },
    tabs: {
      overview: 'Resumen',
      connection: 'Conexión SAML',
      oidcConnection: 'Conexión OIDC',
      identity: 'Identidad',
      activity: 'Actividad',
    },
    tabHints: {
      connection: 'Estos valores definen la relación de confianza con el proveedor de identidad. Cambiarlos afecta al login de inmediato.',
      identity: 'Cómo un login de este proveedor se convierte en un usuario de Smart Point, y en qué Community.',
      activity: 'Lo que esta integración ha hecho realmente, y cada cambio administrativo sobre ella.',
    },
    summary: {
      checking: 'Comprobando la configuración…',
      checkFailed: 'No se ha podido comprobar la configuración',
      readyToEnable: 'Lista para activar',
      readyToEnableHint: 'La configuración está completa. Actívala desde la tarjeta General de abajo.',
      notReady: 'Todavía no se puede activar',
      healthyActive: 'Activa y bien configurada',
      healthyActiveHint: 'Los usuarios de las Communities del ámbito pueden autenticarse con este proveedor.',
      brokenActive: 'Activa, pero su configuración haría fallar todos los logins',
      activeWithWarnings: 'Activa, pero hay pasos que revisar',
      enableableWithWarnings: 'Se puede activar, pero hay pasos que revisar',
    },
    setup: {
      fixMarked: 'Los pasos de abajo dicen qué falta y dónde arreglarlo.',
      steps: {
        connection: 'Conectar el proveedor',
        identity: 'Reconocer al usuario',
        communities: 'Elegir la Community',
        activation: 'Activar el login',
      },
      open: {
        connection: 'Ir a conexión',
        identity: 'Ir a identidad',
      },
      missing: 'Falta: {0}.',
      pieces: {
        issuer: 'issuer',
        ssoUrl: 'IdP SSO URL',
        certificate: 'certificado',
        certificateInvalid: 'un certificado legible',
        spEntityId: 'SP Entity ID',
        oidcProvider: 'issuer y cliente',
        clientSecret: 'client secret',
      },
      connection: {
        samlDone: 'Confía en {0}.',
        oidcDone: 'Inicia sesión con {0} como cliente {1}.',
      },
      identity: {
        nameId: 'el NameID',
        sub: 'el claim sub',
        done: 'Se reconoce por {0}, el email se lee de {1}.',
        noEmail: 'Se reconoce por {0}. No hay email mapeado, así que solo pueden entrar usuarios ya vinculados.',
        emailUnverifiable: 'Se reconoce por {0}. El email se lee de {1}, que el proveedor no verifica, así que solo pueden entrar usuarios ya vinculados.',
        doneOidc: 'Se reconoce por {0}; el email se lee de {1} y solo se usa si el proveedor lo marca como verificado.',
      },
      communities: {
        empty: 'No hay ninguna Community en el ámbito, así que todavía no puede entrar nadie.',
        noMappings: 'La Community se lee del proveedor, pero todavía no hay ningún valor mapeado a una.',
        noReference: 'La Community se lee del proveedor, pero no hay nada mapeado a la referencia de Community.',
        jitWithoutEmail: 'El JIT está activado, pero no hay un email utilizable con el que crear usuarios.',
        jitNeedsOne: 'No se pueden crear usuarios nuevos: el JIT necesita exactamente una Community en el ámbito y hay {0}.',
        fixed: 'Fija, 1 Community en el ámbito. | Fija, {scope} Communities en el ámbito.',
        mapped: 'Se lee del proveedor, {mappings} mapeados, 1 Community en el ámbito. | Se lee del proveedor, {mappings} mapeados, {scope} Communities en el ámbito.',
        jitOn: 'Los usuarios nuevos se crean en su primer login.',
        jitOff: 'Solo pueden entrar usuarios que ya existen.',
      },
      activation: {
        active: 'Activa y pasa todas las comprobaciones.',
        ready: 'Todavía no está activa, así que nadie puede entrar con ella.',
        blocked: 'No se puede activar hasta arreglar esto:',
        broken: 'Está activa, pero esto hace fallar todos los logins:',
      },
    },
    protocols: {
      saml: 'SAML',
      oidc: 'OpenID Connect',
    },
    list: {
      integration: 'Integración',
      provider: 'Proveedor de identidad',
      credential: 'Credencial',
      linkedIdentities: 'Identidades',
      noIssuer: 'Sin issuer todavía',
      providerMissing: 'Sin configurar',
      jit: 'JIT',
      jitHint: 'Crea los usuarios nuevos en su primer login',
    },
    sections: {
      portalAccess: 'Acceso al portal',
      general: 'General',
      authentication: 'Autenticación',
      scope: 'Ámbito de comunidades',
      jit: 'Aprovisionamiento JIT',
      attributeMapping: 'Mapeo de atributos de identidad',
      communityResolution: 'Resolución de Community',
      certificate: 'Certificado del IdP',
      identities: 'Identidades vinculadas',
      audit: 'Auditoría de cambios',
      oidcProvider: 'Proveedor OpenID',
    },
    actions: {
      enable: 'Activar',
      disable: 'Desactivar',
    },
    fields: {
      name: 'Nombre',
      slug: 'Slug',
      slugHint: 'Solo minúsculas, números y guiones. Ej: mi-partner',
      slugInvalid: 'Solo minúsculas, números y guiones',
      protocol: 'Protocolo',
      protocolReadOnly: 'No se puede cambiar después de crear la integración',
      uuid: 'UUID',
      uuidReadOnly: 'Identificador estable generado por el servidor',
      status: 'Estado',
      issuer: 'Issuer (entityID del IdP)',
      issuerHint: 'Debe coincidir exactamente con el Issuer que envía el IdP en la respuesta SAML',
      idpSsoUrl: 'URL de SSO del IdP',
      idpSsoUrlHint: 'Endpoint de inicio de sesión del proveedor de identidad',
      spEntityId: 'SP Entity ID',
      spEntityIdHint: 'Identificador de Smart Point que hay que dar de alta en el IdP',
      communities: 'Comunidades',
      jit: 'Aprovisionamiento JIT',
      urlInvalid: 'Debe ser una URL http o https',
    },
    canonicalFields: {
      external_subject: 'Sujeto externo',
      email: 'Email',
      first_name: 'Nombre',
      last_name: 'Apellidos',
      community_reference: 'Referencia de Community',
    },
    canonicalFieldHints: {
      external_subject: 'Identifica al usuario en esta integración. No cambia nunca una vez hay identidades enlazadas',
      email: 'Necesario para el enlace automático y el aprovisionamiento JIT',
      first_name: 'Opcional. Solo se usa al crear el usuario',
      last_name: 'Opcional. Solo se usa al crear el usuario',
      community_reference: 'Valor que envía el proveedor para identificar la Community. Solo se usa en modo mapeo por atributo',
    },
    attributeMapping: {
      hint: 'Cada proveedor de identidad llama a estos valores de una forma distinta. Indica aquí cómo los llama este. Deja un campo vacío para no leerlo.',
      source: 'Origen',
      attributeName: 'Atributo SAML',
      attributeNamePlaceholder: 'Nombre que envía el proveedor',
      sources: {
        name_id: 'NameID',
        attribute: 'Atributo SAML',
      },
      nameIdSelected: 'El sujeto externo se toma del NameID del SAML. Es el valor por defecto y lo que usaban las integraciones antes de que existiera el mapeo de atributos.',
      communityReferenceUnused: 'Todavía no se usa: la resolución de Community está en «Community fija». Mapéalo aquí primero para poder cambiar a «Mapeo por atributo».',
      communityReferenceRequired: 'La resolución de Community está en «Mapeo por atributo», que necesita este valor: sin él ningún login podrá resolver una Community.',
      communityReferenceRequiredActive: 'Esta integración está activa, así que el cambio no se puede guardar hasta que lo rellenes o vuelvas a «Community fija».',
      externalSubjectWarning: 'Esta integración tiene 1 identidad enlazada. Cambiar el sujeto externo hará que deje de reconocerse. | Esta integración tiene {count} identidades enlazadas. Cambiar el sujeto externo hará que dejen de reconocerse.',
      confirmTitle: '¿Cambiar el sujeto externo?',
      confirmBody: 'Las identidades ya enlazadas a esta integración se guardaron con el sujeto externo actual. Tras este cambio dejarán de reconocerse: según la configuración se volverán a enlazar por email, se crearán de nuevo por JIT, o se rechazarán.',
      confirmNoMigration: 'Los enlaces existentes no se reescriben nunca automáticamente. No hay forma segura de hacerlo, así que debe hacerse de forma deliberada.',
      confirmAction: 'Cambiarlo igualmente',
      field: 'Campo de Smart Point',
      oidc: {
        hint: 'Cada proveedor de identidad llama a estos claims de forma distinta. Indica aquí qué claim del ID Token lleva cada valor. Deja un campo vacío para no leerlo.',
        attributeName: 'Claim del ID Token',
        attributeNamePlaceholder: 'Nombre del claim en el ID Token',
        sources: {
          name_id: 'Claim sub',
          attribute: 'Otro claim',
        },
        nameIdSelected: 'El sujeto externo es el claim sub del ID Token. Es el valor por defecto.',
        noFallback: 'Si un ID Token no trae este claim, el login se rechaza. No se recurre a sub ni al email.',
        emailHint: 'Usa el claim email: es el único que un proveedor marca como verificado, y solo un email verificado vincula o crea cuentas',
        emailUnverifiable: 'El email se lee de {0}. Solo el claim email viene con verificación (email_verified), así que esta dirección nunca vinculará ni creará cuentas.',
      },
    },
    oidc: {
      hint: 'El proveedor OpenID Connect con el que inician sesión los usuarios. Sus endpoints y claves de firma se leen de su documento de Discovery, así que basta con el issuer y el cliente.',
      issuer: 'Issuer',
      issuerHint: 'Exactamente el iss de los ID Tokens del proveedor, carácter a carácter: la barra final cuenta. P. ej. https://www.chainels.com',
      clientId: 'Client ID',
      clientIdHint: 'El client (application) ID registrado para Smart Point en el proveedor',
      clientSecret: 'Client secret',
      clientSecretHint: 'Solo escritura: se guarda cifrado y no se vuelve a mostrar',
      clientSecretKeepHint: 'Hay un secreto configurado. Déjalo vacío para conservarlo, o escribe uno nuevo para sustituirlo',
      secretConfigured: 'Secreto configurado',
      secretMissing: 'Sin secreto',
      tokenEndpointAuthMethod: 'Autenticación en el token endpoint',
      tokenEndpointAuthMethodHint: 'Cómo presenta Smart Point el secreto al proveedor. Usa el que documente el proveedor',
      authMethods: {
        client_secret_basic: 'client_secret_basic (cabecera HTTP Basic)',
        client_secret_post: 'client_secret_post (cuerpo del formulario)',
      },
      scopes: 'Scopes',
      scopesHint: 'Separados por espacios. openid es obligatorio',
      discoveryUrl: 'URL de Discovery (opcional)',
      discoveryUrlHint: 'Solo si el proveedor no la publica en <issuer>/.well-known/openid-configuration. El issuer se comprueba igualmente',
      redirectUri: 'Redirect URI a registrar en el proveedor',
      redirectUriHint: 'Regístrala con el host de H2 del entorno delante: https://h2.smartpoint.ai/h2/oidc/callback en producción, https://s2.h2.smartpoint.ai/h2/oidc/callback en staging',
      loginUrl: 'Enlace de inicio de sesión',
      loginUrlHint: 'En el mismo host de H2 que la redirect URI. Es el enlace que abren los usuarios o el partner para iniciar sesión',
      issuerInvalid: 'Debe ser una URL https sin query (?) ni fragmento (#)',
      discoveryUrlInvalid: 'Debe ser una URL https sin fragmento (#)',
      openidRequired: 'openid es obligatorio',
      confirmIssuerTitle: '¿Cambiar el issuer?',
      confirmIssuerBody: 'Las identidades ya enlazadas a esta integración las emitió el issuer actual. Sus enlaces se quedan como están, así que tras este cambio quien reciba el mismo sub del nuevo issuer entrará como ese usuario enlazado. Confírmalo solo si es el mismo proveedor con otra dirección.',
    },
    communityResolution: {
      hint: 'En qué Community se aprovisiona un login.',
      unsavedMode: 'Guarda el modo para poder configurar sus mapeos.',
      missingReferenceWarning: 'No hay nada mapeado a la referencia de Community. Sin ella no se puede resolver ninguna Community y todos los logins fallarán.',
      modes: {
        fixed: 'Community fija',
        fixedHint: 'No se lee del proveedor. Los usuarios nuevos (JIT) van a la única Community del ámbito, así que el JIT necesita exactamente una',
        attribute_mapping: 'Mapeo por atributo',
        attributeMappingHint: 'La Community se resuelve a partir del valor que envía el proveedor',
      },
      mappingsTitle: 'Mapeos de Community',
      addMapping: 'Añadir mapeo',
      editMapping: 'Editar mapeo',
      externalValue: 'Valor externo',
      externalValueHint: 'Exactamente como lo envía el proveedor. Se compara de forma literal',
      smartPointCommunity: 'Community de Smart Point',
      communityHint: 'Solo Communities dentro del ámbito de esta integración',
      noScopedCommunities: 'El ámbito de esta integración no tiene ninguna Community',
      searchExternalValue: 'Buscar por valor externo',
      noMappings: 'Todavía no hay mapeos',
      removeTitle: '¿Eliminar este mapeo?',
      removeBody: 'Los logins que envíen "{0}" dejarán de resolver a una Community y se rechazarán.',
      removeKeepsUsers: 'Los usuarios ya creados a través de él no se ven afectados.',
    },
    portalAccess: {
      hint: 'Un PIN permite a este partner abrir el portal de desarrollo y leer la documentación de su propia integración. No es un login de Smart Point y no da acceso a ninguna Community.',
      configured: 'PIN configurado',
      missing: 'Sin PIN',
      unreadable: 'Ilegible',
      missingAlert: 'Esta integración no tiene PIN, así que nadie puede abrir el portal en su nombre.',
      unreadableAlert: 'El PIN guardado no se puede leer. Sustitúyelo para restaurar el acceso.',
      revealAction: 'Ver PIN',
      customAction: 'Poner un PIN propio',
      hide: 'Ocultar',
      copy: 'Copiar',
      dialogTitle: 'PIN del portal',
      dialogBody: 'Cópialo ahora. Al cerrar este diálogo se olvida, y volver a verlo es una petición nueva.',
      copyAndClose: 'Copiar y cerrar',
      copied: 'PIN copiado',
      regenerateAction: 'Generar un PIN nuevo',
      replaceLabel: 'PIN nuevo',
      replaceHint: 'Define un PIN propio en lugar de uno generado.',
      replaceAction: 'Sustituir PIN',
      revokeAction: 'Revocar PIN',
      regenerated: 'PIN nuevo generado',
      replaced: 'PIN sustituido',
      revoked: 'PIN revocado',
      confirmRegenerateTitle: '¿Generar un PIN nuevo?',
      confirmFirstBody: 'El PIN se muestra una sola vez, justo tras generarlo. Cópialo antes de salir de esta página.',
      confirmReplaceTitle: '¿Sustituir el PIN?',
      confirmReplaceBody: 'El PIN actual deja de funcionar de inmediato. Quien lo siga usando perderá el acceso al portal.',
      confirmRevokeTitle: '¿Revocar el PIN?',
      confirmRevokeBody: 'La integración dejará de poder abrir el portal de desarrollo. El login con ella no se ve afectado.',
    },
    create: {
      title: 'Nueva integración de identidad',
      startsInactive: 'La integración se crea inactiva. Podrás activarla cuando el issuer, la URL de SSO y el certificado estén configurados.',
      startsInactiveOidc: 'La integración se crea inactiva. Podrás activarla cuando el issuer, el client ID y el client secret estén configurados.',
      created: 'Integración creada',
    },
    disable: {
      title: '¿Desactivar esta integración?',
      willStopAuthentication: 'Los usuarios dejarán de poder autenticarse a través de esta integración de forma inmediata.',
      linksRemain: 'Las identidades ya vinculadas se conservan.',
    },
    scope: {
      hint: 'Quitar una comunidad del ámbito impide que sus usuarios se autentiquen a través de esta integración. Las identidades ya vinculadas no se borran.',
      emptyWarning: 'El ámbito está vacío: esta integración no autentica a nadie.',
      saved: 'Ámbito actualizado',
    },
    jit: {
      hint: 'Crea el usuario en Smart Point la primera vez que se autentica, si no existe.',
      noCommunityWarning: 'El JIT está activado pero el ámbito no tiene ninguna comunidad, así que no se aprovisionará ningún usuario automáticamente.',
      manyCommunitiesWarning: 'El JIT está activado y el ámbito tiene {0} comunidades. Al no poder determinar una única comunidad, no se aprovisionará ningún usuario automáticamente.',
      noCommunityMappingWarning: 'El JIT está activado con mapeo por atributo pero no hay ningún mapeo configurado, así que no se puede resolver ninguna Community.',
      noEmail: 'No hay email mapeado, así que nadie se vincula por email ni se crea por JIT.',
      emailUnverifiable: 'El email se lee de un claim que el proveedor no verifica, así que nadie se vincula por email ni se crea por JIT. Mapéalo al claim email.',
    },
    certificate: {
      hint: 'Certificado público de firma del IdP. Nunca se muestra su contenido: solo su huella y sus metadatos.',
      installed: 'Instalado',
      missing: 'Sin certificado',
      invalid: 'No válido',
      missingAlert: 'Esta integración no tiene certificado, así que no puede activarse.',
      invalidAlert: 'El certificado almacenado no se puede interpretar. Reemplázalo para poder autenticar.',
      fingerprint: 'Huella SHA-256',
      subject: 'Sujeto',
      issuerDn: 'Emisor',
      validFrom: 'Válido desde',
      validTo: 'Válido hasta',
      expired: 'Caducado',
      replaceLabel: 'Nuevo certificado',
      replaceHint: 'Pega el certificado en PEM o en base64. Solo se admite un certificado: el nuevo sustituye al anterior.',
      replaceAction: 'Reemplazar certificado',
      saveReplacement: 'Guardar el certificado nuevo',
      installAction: 'Instalar certificado',
      confirmTitle: '¿Reemplazar el certificado?',
      confirmBody: 'La relación de confianza SAML cambia de inmediato. Las respuestas firmadas con el certificado anterior dejarán de ser válidas.',
      replaced: 'Certificado reemplazado',
    },
    identities: {
      hint: 'Vínculos entre identidades externas y usuarios de Smart Point creados por esta integración.',
      empty: 'Todavía no hay identidades vinculadas',
      user: 'Usuario',
      linkMethod: 'Método de vinculación',
      emailAtLinkTime: 'Email al vincular',
      linkedAt: 'Vinculado el',
      methods: {
        existing: 'Usuario existente',
        verified_email: 'Email verificado',
        jit: 'JIT',
      },
    },
    audit: {
      hint: 'Cambios administrativos sobre la configuración de esta integración.',
      empty: 'Todavía no hay cambios registrados',
      actionFilter: 'Tipo de cambio',
      actions: {
        insert: 'Creación',
        update: 'Modificación',
        delete: 'Borrado',
      },
      unknownActor: 'Desconocido',
      none: 'vacío',
      noSafeFields: 'Sin campos mostrables',
      protocolSubject: 'subject (NameID / sub)',
      by: 'por {0}',
      credentialStates: {
        set: 'Configurado',
        replaced: 'Reemplazado',
      },
    },
    auditFields: {
      name: 'Nombre',
      slug: 'Slug',
      status: 'Estado',
      protocol: 'Protocolo',
      issuer: 'Issuer',
      idp_sso_url: 'URL de SSO del IdP',
      sp_entity_id: 'SP Entity ID',
      idp_certificate: 'Certificado (huella)',
      jit_provisioning_enabled: 'Aprovisionamiento JIT',
      email_attribute: 'Atributo de email',
      attribute_mappings: 'Mapeo de atributos',
      community_mapping: 'Mapeo de Community',
      community_resolution_mode: 'Resolución de Community',
      community_ids: 'Comunidades',
      portal_pin: 'PIN del portal',
      oidc: {
        issuer: 'Issuer OIDC',
        discovery_url: 'URL de Discovery',
        client_id: 'Client ID',
        client_secret: 'Client secret',
        token_endpoint_auth_method: 'Autenticación en el token endpoint',
        scopes: 'Scopes',
      },
    },
    errors: {
      required: 'Este campo es obligatorio',
      unique: 'Este valor ya está en uso',
      regex: 'El formato no es válido',
      in: 'El valor no está admitido',
      max: 'El valor es demasiado largo',
      string: 'El valor no es válido',
      url: 'Debe ser una URL válida',
      boolean: 'El valor no es válido',
      exists: 'La comunidad seleccionada no existe',
      invalid: 'El valor no es válido',
      issuerRequired: 'Para activar la integración hace falta configurar el issuer',
      idpSsoUrlRequired: 'Para activar la integración hace falta configurar la URL de SSO del IdP',
      certificateRequired: 'Para activar la integración hace falta un certificado válido',
      spEntityIdRequired: 'Activar la integración requiere que el SP Entity ID esté configurado',
      externalSubjectAttributeRequired: 'Indica el atributo o claim del que se lee el sujeto externo',
      emailMappingRequired: 'Para leer la Community del proveedor, mapea también el email',
      communityReferenceMappingRequired: 'Para leer la Community del proveedor, mapea la referencia de Community',
      communityMappingsRequired: 'El mapeo por atributo requiere al menos un mapeo de Community',
      communityMappingOutOfScope: 'Un mapeo de Community apunta a una Community fuera del ámbito de esta integración',
      externalSubjectMappingChangeRejected: 'Esta integración tiene identidades enlazadas. Confirma el cambio para aplicarlo',
      oidcConfigurationRequired: 'Para estar activa, la integración necesita su proveedor OpenID configurado',
      oidcIssuerRequired: 'Para estar activa, la integración necesita el issuer',
      oidcClientIdRequired: 'Para estar activa, la integración necesita el client ID',
      oidcClientSecretRequired: 'Para estar activa, la integración necesita un client secret legible. Vuelve a introducirlo',
      notApplicableToProtocol: 'Este ajuste no se aplica a este protocolo',
      oidcIssuerChangeRejected: 'Esta integración tiene identidades enlazadas. Confirma el cambio de issuer para aplicarlo',
      mutableExternalSubjectClaim: 'Este claim puede pasar a otra persona (una dirección o un usuario). Usa sub o un identificador estable, como un número de empleado',
      status400: 'La petición no es válida',
      status401: 'No tienes permiso para hacer esto',
      status403: 'No tienes permiso para hacer esto',
      status404: 'Esta integración ya no existe',
      status409: 'El cambio choca con el estado actual',
      status422: 'El cambio no cumple una precondición',
      status500: 'Se ha producido un error en el servidor',
      unexpected: 'Se ha producido un error',
    },
  },
  charts: {
    showTable: 'Tabla',
    showChart: 'Gráfico',
    day: 'Día',
  },
  auditLogs: {
    title: 'Audit Logs',
    subtitle: 'Todos los cambios registrados en la tabla audit_logs',
    noData: 'No hay registros de auditoría',
    emptyFiltered: 'Ningún registro de auditoría coincide con estos filtros',
    system: 'Sistema / Cola',
    empty: '(vacío)',
    softDeleteHint: 'Soft delete de usuario: la fila se actualizó para anonimizar al usuario (DELETED USER), no se borró',
    actions: {
      insert: 'Alta',
      update: 'Modificación',
      delete: 'Baja',
    },
    fields: {
      id: 'ID',
      date: 'Fecha',
      type: 'Tipo (tabla)',
      action: 'Acción',
      record: 'Registro',
      recordId: 'ID registro',
      changedFields: 'Campos modificados',
      changedBy: 'Modificado por',
      ip: 'IP',
      userAgent: 'User agent',
    },
    filters: {
      title: 'Filtros',
      all: 'Todos',
      allActions: 'Todas',
      authorPlaceholder: 'Buscar por nombre o email…',
      authorTooShort: 'Escribe al menos 2 caracteres',
      authorNoResults: 'Ningún usuario con registros coincide',
      filterByThis: 'Filtrar por este valor',
      periods: {
        always: 'Siempre',
        today: 'Hoy',
        last7: 'Últimos 7 días',
        last30: 'Últimos 30 días',
        custom: 'Personalizado…',
      },
      search: 'Buscar',
      searchPlaceholder: 'Cualquier texto de los datos, usuario, IP…',
      period: 'Periodo',
      clear: 'Limpiar filtros',
    },
    charts: {
      lastDays: 'últimos {days} días',
      totalCaption: 'en los últimos {days} días',
      dataFrom: 'Datos de las {time} ({date})',
      cachedFor: 'Se actualiza cada {minutes} min',
      refresh: 'Refrescar',
      clickHint: 'Clic para ver los registros de ese día',
      registered_users: {
        tab: 'Altas',
        title: 'Usuarios registrados por día',
        unit: 'usuarios',
        empty: 'Ningún usuario registrado en los últimos {days} días',
      },
      deleted_users: {
        tab: 'Usuarios borrados',
        title: 'Usuarios borrados por día',
        unit: 'usuarios',
        empty: 'Ningún usuario borrado en los últimos {days} días',
      },
      created_service_providers: {
        tab: 'Nuevos proveedores',
        title: 'Proveedores de servicio creados por día',
        unit: 'proveedores',
        empty: 'Ningún proveedor creado en los últimos {days} días',
      },
      top_editors: {
        title: 'Top editores',
        subtitle: 'Los {limit} usuarios con más cambios en cualquier tabla · últimos {days} días',
        centerCaption: 'cambios',
        empty: 'Ningún usuario hizo cambios en los últimos {days} días',
        clickHint: 'Clic en una persona para ver sus cambios',
      },
    },
    detail: {
      recordHistory: 'Historial de este registro',
      authorChanges: 'Cambios de este usuario',
      changes: 'Cambios',
      oldData: 'Datos anteriores',
      newData: 'Datos nuevos',
      field: 'Campo',
      before: 'Antes',
      after: 'Después',
      noChanges: 'Este registro no tiene datos de campos',
    },
  },
  apiKeys: {
    title: 'API Keys',
    subtitle: 'Gestiona el acceso de integraciones externas a la API',
    fields: {
      name: 'Nombre',
      status: 'Estado',
      endpoints: 'Endpoints',
      lastUsedAt: 'Último uso',
      neverUsed: 'Nunca usada',
      noEndpoints: 'Sin endpoints asignados',
    },
    status: {
      active: 'Activa',
      revoked: 'Revocada',
    },
    actions: {
      revoke: 'Revocar key',
    },
    empty: 'Todavía no se ha creado ninguna API key',
    createModal: {
      title: 'Nueva API key',
      endpointsLabel: 'Endpoints permitidos',
      endpointsHint: 'Los endpoints de esta lista se registran desde el backend (rutas + migraciones); no se pueden añadir desde aquí.',
    },
    revealModal: {
      title: 'API key generada',
      warning: 'Copia esta key ahora. No se volverá a mostrar.',
      copied: 'Copiada al portapapeles',
      copy: 'Copiar',
      headerHint: 'Envíala en la cabecera X-API-KEY de cada request a un endpoint protegido.',
    },
    revokeConfirm: {
      title: '¿Revocar esta API key?',
    },
    guide: {
      button: 'Guía de uso',
      intro: 'Proteger un endpoint nuevo requiere dos pasos, ambos manuales y a propósito: así nadie protege (o desprotege) un endpoint sin querer.',
      step1: {
        title: 'Middleware en la ruta',
        text: 'En el fichero de rutas correspondiente (routes_modulo.php, routes_gmp.php, etc.) añade el middleware indicando un slug como parámetro:',
        note: 'El slug es un identificador libre que tú eliges (la convención habitual es algo.algo), pero puede ser cualquier string único.',
      },
      step2: {
        title: 'Migración que registra el slug en el catálogo',
        text: 'Una migración pequeña (mismo patrón que add_api_keys_auth_management_permission_map.php) inserta una fila en api_keys_auth_endpoints:',
      },
      runtime: {
        title: 'Cómo funciona en tiempo de ejecución',
        step1: 'El middleware lee el header X-API-KEY de la request.',
        step2: 'Calcula su hash SHA-256 y busca una key activa (no revocada) con ese hash.',
        step3: 'Comprueba si esa key tiene asignado el endpoint cuyo slug es el indicado en la ruta.',
        step4: 'Si todo es correcto, deja pasar la request y actualiza last_used_at. Si no: 401 (key inválida o revocada) o 403 (key válida pero sin acceso a ese endpoint).',
      },
      assignmentNote: 'La asignación key ↔ endpoint no se toca por migración: se gestiona desde este backoffice, eligiendo de la lista de endpoints del catálogo al crear o revisar una key.',
    },
  },
  standalone: {
    list: {
      installCode: 'Cód. Instalación',
      demo: 'demo',
      deviceId: 'ID dispositivo',
      deviceCode: 'Código dispositivo',
      lastPing: 'Último ping',
      health: 'Salud',
        statuses: {
            title: 'Estado',
            online: 'Online',
            off: 'Offline',
        },
      metrics: 'Métricas',
      logs_location: {
            title: 'Destino Logs',
            volatile: 'Mem. Volátil',
            persistent: 'Disco',
            auto: 'Automático'
      },
      actions: {
            title: 'Acciones',
            titles: {
                preview: 'Vista previa',
                reboot: 'Reiniciar dispositivo',
                screenshot: 'Captura de pantalla',
                ssh: 'Acceso SSH',
                refresh: 'Refrescar navegador',
                markDemo: 'Marcar como demo',
            }
      },
      deviceType: 'Tipo dispositivo',
      country: 'País',
      search: 'Buscar en ID, cód. instalación, ID dispositivo, comunidad, país',
      deleted: 'Eliminados',
      showDeleted: 'Mostrar eliminados',
    },
    ssh:{
        titlePopUp: 'Conexión SSH',
        descriptionPopUp: 'Solicitar conexión SSH'
    },
    demo: {
        title: 'Pasar a demo',
        description: '¿Estás seguro que quieres pasarlo a demo?',
    },
    screenshot:{
        title: 'Standalone Screenshot',
        refresh: 'Solicitar o refrescar',
        requestSent: 'Petición lanzada',
        waitingrefresh: 'Esperando a refrescar:'
    },
    refresh:{
      title: 'Refrescar navegador',
      description: 'Refrescar navegador sin reiniciar standalone',
    },
    detail: {
      title: 'Detalle del portal digital',
      saved: 'Cambios guardados',
      name: {
        title: 'Nombre',
      },
      sim: {
        title: 'Identificador SIM',
        saved: 'Código SIM guardado',
      },
      sections: {
        data: 'Datos',
        management: 'Gestión',
      },
      delete: {
        hard: 'Eliminar permanentemente',
        soft: 'Eliminar (soft delete)',
        confirmHard: '¿Estás seguro de que quieres eliminar este portal digital de forma permanente? Esta acción no se puede deshacer.',
        confirmSoft: '¿Estás seguro de que quieres eliminar este portal digital? El dispositivo quedará marcado como eliminado en el sistema.',
        success: 'Portal digital eliminado',
      },
    },
  },
  timeSlots: {
    timeSlotRestrictions: {
      headers: {
        data: 'Sujeto',
      },
      noRestrictions: 'Sin restricciones',
      targets: {
        0: 'ambos',
        1: 'recogida',
        2: 'reparto',
      },
      types: {
        10: {
          label: 'Horario',
          hint: 'Horario normal, cuando se hacen rutas',
        },
        21: {
          label: 'Offset min.',
          hint: 'No se ofrece slots dentro de este plazo, eg. min 2 horas para recoger',
        },
        22: {
          label: 'Offset min.',
          hint: 'No se ofrece slots dentro de este plazo, eg. min 2 dias para repartir',
        },
        31: {
          label: 'Offset max.',
          hint: 'No se ofrece slots fuera de este plazo, eg. max 24 horas para recoger',
        },
        32: {
          label: 'Offset max.',
          hint: 'No se ofrece slots fuera de este plazo, eg. max 7 dias para repartir',
        },
        41: {
          label: 'Max per slot',
          hint: 'Limitar cantidad de pedidos dentro de un slot',
        },
        42: {
          label: 'Internal',
          hint: 'Uso internal',
        },
        123: {
          label: 'Holiday',
          hint: 'Fiestas, dias cuando no se hacen rutas',
        },
        124: {
          label: 'Zona',
          hint: 'Restringir zonas',
        },
      },
    },
  },
  clients: {
    list: {
      title: 'Clientes',
      create: 'Nuevo cliente',
    },
    detail: {
      title: 'Cliente',
      basicInfo: 'Información básica',
      contacts: 'Contactos',
    },
    edit: {
      title: 'Editar cliente',
    },
    create: {
      title: 'Nuevo cliente',
    },
    nav: {
      details: 'Detalles',
      edit: 'Editar',
      communities: 'Comunidades',
    },
    fields: {
      legalName: 'Nombre legal',
      principalContact: 'Contacto principal',
      invoicingContact: 'Contacto de facturación',
      contactHint: 'Introduce el ID del usuario',
    },
    stats: {
      communities: 'Comunidades (total)',
      lockers: 'Lockers (total)',
      standalones: 'Digital Portals (total)',
      users: 'Usuarios (total)',
    },
  },
  communities: {
    nav: {
      list: 'Lista',
      details: 'Detalles',
      edit: 'Editar',
      lockers: 'Lockers',
      standalones: 'Digital Portals',
      invitationLinks: 'Invitation Links',
      contacts: 'Contactos',
      orders: 'Pedidos',
      serviceProviders: 'Proveedores',
      users: 'Usuarios',
    },
    configuration: {
      notEnabled: 'Este módulo no está activo en esta comunidad.',
      enableIt: 'Actívalo en Editar',
      discard: 'Descartar cambios',
      metadataOnly: 'Solo se guarda como referencia. No activa nada.',
      none: 'Ninguna',
      noneHelp: 'Nada registrado para esta comunidad',
      regular: 'Regular',
      regularHelp: 'Las plantillas estándar de Smart Point, por los canales que elijas',
      custom: 'Personalizado',
      customHelp: 'Las plantillas de notificación propias de la comunidad, por los canales que elijas',
      noCustomTemplates: 'La opción de plantillas personalizadas aún no está configurada',
      channels: 'Canales',
      chooseChannel: 'Elige al menos un canal para guardar',
      chooseIntegrationType: 'Elige un tipo de integración para guardar',
      communication: 'Comunicación',
      communicationHelp: 'Cómo llegan los eventos de la comunidad al partner. Opcional.',
      labels: {
        default: 'Opción',
        integrations: 'Tipo de integración',
        notifications: 'Envío de notificaciones',
      },
    },
    notifications: {
      standard: 'Plantilla estándar',
      custom: 'Plantilla propia',
      loadFailed: 'No se han podido cargar las plantillas. Recarga la página para volver a intentarlo.',
      channels: {
        email: 'Email',
        sms: 'SMS',
        push: 'Push',
      },
    },
    serviceProviders: {
      title: 'Proveedores',
      communityRestricted: 'Este proveedor está restringido a comunidades específicas y no puede asignarse a esta comunidad',
      channelInconsistency: 'Inconsistencia de canal entre la comunidad y este proveedor de servicio',
      assignedOK: 'El servicio {name} se asignó correctamente',
    },
    users: {
      title: 'Usuarios de',
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      createdAt: 'Fecha de alta',
      active: 'Activo',
      inactive: 'Inactivo',
    },
    invitationLinks: {
      title: 'Invitation Links',
      copyTooltip: 'Copiar código',
      copied: 'Código copiado',
      deleteDisabledHint: 'No se puede eliminar un enlace ya utilizado',
      fields: {
        code: 'Código',
        permission: 'Permiso',
        usedBy: 'Estado',
        usedByEmail: 'Usado por',
      },
      permissions: {
        lockerOwner: 'Locker Owner',
        lockerOperator: 'Locker Operator',
      },
      status: {
        used: 'Usado',
        unused: 'Sin usar',
      },
      createModal: {
        title: 'Crear invitation link',
        permissionLabel: 'Nivel de permiso',
        implicitPermissionNote: 'Además del permiso seleccionado, se asignará implícitamente el permiso 520 (Dashboard).',
        noOnlineLockerWarning: 'Este enlace está destinado exclusivamente a usuarios B2B de comunidades equipadas con Lockers o Portales Digitales. Compartirlo con otras personas puede resultar en una experiencia de interfaz incompleta.',
        noSendLink: 'Entiendo y quiero continuar',
      },
    },
    list: {
      title: 'Comunidades',
      create: 'Nueva comunidad',
      csvExportHint: 'Descarga un CSV con todas las comunidades y el número de SmartPoints asociados.',
      csvLimitTitle: 'Límite de filas alcanzado',
      csvLimitText: 'Estás descargando más de 2000 comunidades, que es el límite máximo. Aplica filtros para acotar los resultados.',
    },
    detail: {
      title: 'Comunidad',
      basicInfo: 'Información básica',
      configuration: 'Configuración',
      location: 'Ubicación',
      lockers: 'Lockers asociados',
      rentbackRewards: 'Recompensas Rentback',
      currentValues: 'Valores actuales',
      financialData: 'Datos financieros',
      tabInfo: 'Info',
      tabFinancial: 'Financiero',
      tabContacts: 'Contactos',
    },
    edit: {
      title: 'Editar comunidad',
      softDelete: 'Soft delete',
      restore: 'Recuperar',
      deleteConfirmTitle: 'Eliminar comunidad',
      deleteConfirmText: '¿Seguro que quieres eliminar esta comunidad? Podrás recuperarla más adelante.',
      restoreConfirmTitle: 'Recuperar comunidad',
      restoreConfirmText: '¿Seguro que quieres recuperar esta comunidad? Quedará como inactiva.',
    },
    create: {
      title: 'Nueva comunidad',
    },
    fields: {
      slug: 'Slug',
      slugHint: 'Dejar vacío para autogenerar desde el nombre',
      channel: 'Canal',
      invitationCode: 'Código de invitación',
      currency: 'Divisa',
      languages: 'Idiomas',
      locationName: 'Nombre de ubicación',
      locationLine1: 'Dirección línea 1',
      locationLine2: 'Dirección línea 2',
      locationCity: 'Ciudad',
      locationPostcode: 'Código postal',
      country: 'País',
      coordinatesLat: 'Latitud',
      coordinatesLong: 'Longitud',
      nativeAppEnabled: 'App nativa activa',
      b2bCommunications: 'Comunicaciones B2B',
      b2bCommunicationsEnabled: 'Comunicaciones B2B activadas',
      rentback: 'Rentback',
      monthlyRentbackCredit: 'Crédito mensual Rent-back',
      rentbackEnabled: 'Rentback activado',
      rentbackDisabled: 'Rentback desactivado',
      rentbackCap: 'Crédito por orden',
      monthlyRentbackCap: 'Crédito mensual por orden',
      clientType: 'Tipo de cliente',
      clientTypes: {
        trial: 'Trial',
        live: 'Live',
      },
      useSecurityCode: 'PIN Code activado',
      modules: 'Módulos',
      modulesSubtitle: 'Selecciona el módulo para activar la funcionalidad',
      integrationType: 'Tipo de integración',
      integrationsData: 'Plantillas de notificación',
      integrationsDataSubtitle: 'La plantilla que envía cada canal a los usuarios de esta comunidad. Solo lectura.',
      integrationsDataTemplate: 'Plantilla',
      integrationsDataTranslationKey: 'Clave de traducción',
      excludedModules: 'Exc. módulos',
      includedModules: 'Inc. módulos',
      client: 'Cliente',
      contractStartDate: 'Fecha inicio contrato',
      contractEndDate: 'Fecha fin contrato',
      maintenanceFee: 'Cuota mantenimiento',
      saasFee: 'Cuota SaaS',
      hardwareFee: 'Cuota hardware',
      hardwareSalePrice: 'Precio venta hardware',
      units: 'Units',
    },
    contacts: {
      title: 'Contactos',
      addContact: 'Añadir contacto',
      role: 'Rol',
      add: 'Añadir',
      email: 'Email',
      invalidEmail: 'Email no válido',
      noContacts: 'Sin contactos asignados',
      addedSuccess: 'Contacto añadido correctamente',
      deleteTitle: 'Eliminar contacto',
      deleteConfirm: '¿Seguro que quieres eliminar este contacto?',
      roles: {
        asset_manager: 'Asset Manager',
        facility_manager: 'Facility Manager',
        marketing_manager: 'Marketing Manager',
        property_manager: 'Property Manager',
      },
    },
    status: {
      active: 'Activa',
      inactive: 'Inactiva',
      deleted: 'Eliminada',
    },
    lockers: {
      address: 'Dirección',
      city: 'Ciudad',
      coordinates: 'Coordenadas',
      machineNumber: 'Nº máquina',
      version: 'Versión',
      identifier: 'Identificador',
    },
    securityCodes: {
      title: 'Pins de seguridad',
      pin: 'PIN Code',
      community: 'Comunidad',
      generatePin: 'Generar PIN',
      createdBy: 'Creado por',
    },
  },

  users: {
    dashboard: {
      details: 'Detalles',
      orders: 'Pedidos',
      expenditure: 'Gastos',
      awaitingCollect: 'Pendiente de recogida',
      inProgress: 'En curso',
      completed: 'Completados',
      totalOrders: 'Total',
      outstanding: 'Pendiente de pago',
      lastWeek: 'Última semana',
      lastMonth: 'Último mes',
      totalSpent: 'Total',
      remoteDelivery: 'Entrega remota',
    },
    communications: {
      title: 'Comunicaciones a',
    },
    details: {
      title: 'Detalles de',
    },
    export: {
      CTA: {
        label: 'Export',
        title: 'Descargar archivo de datos basicos de usuarios',
      },
    },
    orders: {
      title: 'Órdenes de',
    },
    promotions: {
      title: 'Promociones de',
      discount: 'Discount',
      usedPromotions: 'Promociones utilizadas',
      coupons: 'Cupones (usados y disponibles)',
      createCoupon: 'Cupón personal para',
    },
    search: {
      title: 'Buscar usuarios',
      hint: 'nombre, email, telefono o código de usuario',
      tooShort: 'sigue...',
      noLuck: 'Sin suerte',
    },
    user: {
      buttons: {
        resendChangePassword: 'Reenviar email de Cambio de Contraseña',
        newDeliveryToken: 'Nuevo código de entrega',
      },
      confirmSendPswEmail: {
        title: 'Reenviar email de cambio de contraseña',
        description: 'El email puede tardar un par de minutos en llegar'
      },
      confirmNewDeliveryToken: {
        title: 'Generar nuevo código de entrega',
        description: 'El código de entrega actual dejará de funcionar inmediatamente'
      },
      fields: {
        accessible: {
          title: 'Movilidad reducida'
        },
        active: {
          title: 'Activo',
        },
        advertising_consent: {
          title: 'Consentimiento de publicidad',
        },
        company_name_for_billing: {
          title: 'Nombre de la empresa para la factura'
        },
        created_at: {
          title: 'Registrado',
        },
        delivery_token: {
          title: 'Codigo de taquilla'
        },
        email: {
          title: 'Correo'
        },
        email_verified: {
          title: 'Verificar correo',
        },
        feature: {
          title: 'Característica',
          values: {
            0: '-',
            20: 'Bizcocho',
            1001: 'G1 API (OBS)',
          },
        },
        first_name: {
          title: 'Nombre',
        },
        internal_dept_name: {
          title: 'Departamento',
        },
        internal_delivery: {
          title: 'Paquetería interna'
        },
        internal_locker_id: {
          title: 'Smart Point',
        },
        invoice_payments: {
          title: 'Pagos de facturas',
        },
        invited_by: {
          title: 'Invitado por:',
        },
        language_code: {
          title: 'Lenguaje',
        },
        last_name: {
          title: 'Apellido'
        },
        last_logged_in: {
          title: 'Conectado por ultima vez',
        },
        uses_native_app: {
          title: 'App móvil',
        },
        locker_company_id: {
          title: 'Empresa o piso',
        },
        locker_id: {
          title: 'ID de Smart Point'
        },
        role: {
          title: 'Rol',
          values: {
            role_administator :'Administador',
            role_driver :'Conductor',
            role_channel_administrator :'Administrador del canal',
            role_service_provider_owner :'Propietario del servicio',
            role_user_client :'Cliente habitual',
            role_locker_owner :'Propietario del Smart Point',
            role_service_provider_operator :'Operador del servicio',
          },
        },
        phone_number: {
          title: 'Numero de telefono',
        },
        phone_number_verified: {
          title: 'Verificar numero',
        },
        status: {
          helps: {
            user_registered: 'Usuario registrado a través de la página de inicio.',
            user_logged_in: 'Usuario ha iniciado sesión al menos una vez.',
            package_received: 'Usuario ya ha recibido un paquete. El envío de paquetes de usuario a usuario no está incluido.',
            order_made: 'Usuario ya ha realizado un pedido.',
          },
          title: 'Status',
          user_registered: 'Usuario registrado',
          user_logged_in: 'Usuario conectado',
          package_received: 'Paquete recibido',
          order_made: 'Pedido realizado',
        },
        spike_address_id: {
          title: 'ID',
        },
        spike_address: {
          title: 'Dirección',
        },
        spike_unit_number: {
          title: 'Número de unidad',
        },
        terms_and_conditions: {
          title: 'Terminos y condiciones',
        },
      },
      spikeInfo: {
        title: 'Dirección Spike V2',
      },
      invoicing: {
        title: 'Facturacion',
      },
      personalInfo: {
        title: 'Informacion personal',
      },
      logs: {
        title: 'Historia',
        actions: {
          10: 'Actualizado por Smart Point',
          11: 'Registrado en Smart Point',
          12: 'Registrado en Smart Point por pedido',
          13: 'Perfil actualizado en webapp (bizcocho)',
          16: 'Registrado por pagina web (obs)',
          17: 'Registro por landingpage (obs)',
          18: 'Registrado por pedido (backoffice)',
          21: 'Smart Point cambiado por pedido en Smart Point',
          22: 'Smart Point cambiado por pedido en backoffice',
          23: 'Smart Point cambiado por registro en Smart Point',
          24: 'Login',
          25: 'Login con recuerdame',
          26: 'Login con URL',
          101: 'Ha asignado nuevo código de usuario a un cliente',
          117: 'Importado usuarios',
          118: 'Exportado usuarios',
          124: 'Migrato a otro Smart Point',
          201: 'Received cupon MGM',
          202: 'Ha creao un cupon',
          203: 'Ha creado una zona',
          204: 'Ha creado un direccion nuevo suyo',
          205: 'Email reiniciar contraseña enviado',
          206: 'Contraseña reiniciada',
        },
        origin: {
          0: '???',
          1: 'locker V3',
          2: 'locker V2',
          3: 'webapp (bizcocho)',
          4: 'sp landing page',
          10: 'API G1',
          20: 'importer',
          21: 'difusiön express',
          30: 'backoffice M1',
          40: 'manual',
        },
      },
      title: 'Usuario',
    },
    userImport: {
      csv: {
        title: 'CSV file',
        placeholder: 'Elige un archivo para continuar',
      },
      ignorePhone: {
        label: 'Ignorar teléfono',
        hint: 'No se lee ni se valida la columna de teléfono. Sin marcar, el teléfono es obligatorio y tiene que ser un móvil válido.',
      },
      overrideLockerUsers: {
        label: 'Override locker users (solo Bayer / reparto interno)',
        hint: 'Para lockers corporativos como Bayer: el CSV pasa a ser la lista completa de usuarios del SmartPoint. Los emails nuevos se crean como usuarios, los residentes que no estén en el CSV se DESACTIVAN (no se borran ni se anonimizan) y los que vuelvan se reactivan. No se envía ningún email a nadie.',
        confirmTitle: 'Override locker users: desactivar residentes que no están en el CSV',
        willDeactivate: 'Se desactivarán {count} de {total} residentes activos de {locker}. Solo {matched} coinciden con el CSV:',
        massDeactivate: 'Vas a desactivar más de la mitad de los residentes del SmartPoint. Comprueba que el CSV y el SmartPoint son los correctos.',
        typeCount: 'Escribe {count} para confirmar',
        nobody: 'No hay usuarios del SmartPoint que desactivar. Se procesará el CSV igualmente.',
        willRestore: 'usuario(s) eliminados antes se restaurarán porque vuelven a estar en el CSV:',
        notDeactivated: 'usuario(s) no se desactivarán por tener pedidos activos:',
        lineErrors: 'línea(s) del CSV tienen errores y no se procesarán',
        confirm: 'Importar y desactivar',
      },
      operation: 'Operación',
      detail: 'Detalle',
      operations: {
        invited: 'Invitado',
        created: 'Creado',
        moved: 'Actualizado',
        restored: 'Restaurado',
        unchanged: 'Sin cambios',
        deactivated: 'Desactivado',
        notDeactivated: 'No desactivado',
        notProcessed: 'Sin procesar',
        error: 'Error',
      },
      details: {
        invited: 'Usuario nuevo: invitación para registrarse',
        invitationSent: 'Usuario nuevo: invitación enviada para registrarse',
        invitationNotSent: 'Usuario nuevo: invitación NO enviada (entorno de pruebas)',
        created: 'Usuario nuevo creado (sin email; entrará con "olvidé mi contraseña")',
        movedFrom: 'Usuario existente movido desde {community} / {locker}',
        noLocker: 'sin SmartPoint',
        assigned: 'Usuario existente asignado a este SmartPoint (no tenía)',
        restored: 'Usuario eliminado anteriormente, restaurado',
        unchanged: 'Ya pertenecía a este SmartPoint o a su comunidad',
        deactivated: 'Desactivado: no está en el CSV',
        reactivated: 'Usuario desactivado de este SmartPoint, reactivado',
        name_updated: 'Ya estaba en este SmartPoint o su comunidad; nombre y apellidos actualizados con los del CSV',
        alsoNameUpdated: 'nombre y apellidos actualizados',
        activeOrders: 'No está en el CSV, pero tiene pedidos activos',
        activeOrdersCount: 'No está en el CSV, pero tiene {count} pedido(s) activo(s)',
        locker_not_available: 'Este SmartPoint no está entre los que puedes gestionar',
        gate_codes_mismatch: 'Su SmartPoint actual tiene códigos de puerta distintos',
        phone_exists: 'El teléfono ya pertenece a otro usuario',
        exception: 'Error inesperado al procesar la línea',
        same_locker: 'Ya estaba en este SmartPoint',
        same_community: 'Ya estaba en otro SmartPoint de la misma comunidad (no se mueve)',
        current_locker_not_available: 'Su SmartPoint actual no está entre los que puedes gestionar',
        email_transport: 'No se pudo enviar el email de invitación (error del servidor de correo)',
      },
      delivery_token: 'Codigo de entrega',
      exampleLink: 'Descargar ejemplo CSV',
      line_number: 'Linea',
      locker: {
        title: 'SmartPoint',
        placeholder: 'Elige un SmartPoint para continuar',
      },
      results: {
        all: 'Todos',
        existingUsersNote: 'A los usuarios que ya existían no se les aplican el nombre, los apellidos ni el teléfono del CSV: solo se cambia su SmartPoint.',
        existingUsersOverrideNote: 'A los usuarios que ya existían se les ponen el nombre y los apellidos del CSV; su teléfono no se cambia.',
        invitationsNotSent: 'invitación(es) no enviadas porque no es el entorno de producción. En producción sí se envían.',
        cntErrors: 'error(es) encontrados',
        cntImported: 'usuario(s) nuevos',
        cntUpdated: 'usuario(s) actualizado SmartPoint',
        notModifiedCnt: 'usuario(s) sin cambio',
        restoredCnt: 'usuario(s) restaurados',
      },
      resultCode: {
        0: 'Header OK',
        10: 'Error desconocido',
        11: 'No se puede recognizar el archivo',
        12: 'No datos en el archivo',
        13: 'Error en la cabecera - por favor usar el ejemplo para empezar. La cabecera y las columnas deben coincidir.',
        100: 'Falta data (columna) en esta linea',
        101: 'Procesado',
        102: 'SmartPoint actualizado',
        103: 'El usuario ya existe',
        104: 'No es posible actualizar',
        105: 'Telefono ya existe (registrado antes)',
        106: 'Usuario restaurado',
        107: 'Se restaurará',
        120: 'Max 1000 usuarios a la vez. Se puede cargar el mismo archivo para continuar.',
        130: 'Procesado',
        199: 'Sin procesar',
        201: 'Email no valido ',
        202: 'Nombre vacio',
        203: 'Apellidos vacios',
        204: 'Teléfono vacío o no válido (tiene que ser un móvil)',
        254: 'Telefono no valido',
        150: 'Desactivado (no está en el CSV)',
        151: 'Se desactivará (no está en el CSV)',
        152: 'No desactivado: tiene pedidos activos',
        153: 'No desactivado: falló la desactivación y no se ha desactivado a nadie',
        160: 'Línea válida (se creará, se moverá o se reactivará)',
        161: 'Línea válida (ya es residente)',
      },
      resultTitle: 'Resultados',
      resultImported: 'Resultado',
      title: 'Plataforma de difusion',
      upload: 'Empezar',
    },
    userList: {
      id: 'Identificador',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      email: 'Correo electronico',
      phone: 'Telefono',
      createdAt: 'Fecha creacion',
      usesNativeApp: 'App móvil',
      active: 'Activo',
      deactivated: 'Desactivado',
      registrationOrigin: 'Origen del registro',
      integration: 'Integración',
      integrated: 'Integrado',
      notIntegrated: 'Sin integración',
      flat: 'Vivienda {flat}',
      origins: {
        unknown: 'Origen desconocido',
        locker_v3: 'Locker V3',
        locker_v2: 'Locker V2',
        web_app: 'App web',
        landing_page: 'Página de registro',
        la_liga: 'La Liga',
        api_g1: 'API G1',
        api_h1: 'API H1',
        api_h2: 'API H2',
        api_x1: 'API X1',
        import: 'Importación',
        diffusion_express: 'Difusión Express',
        backoffice: 'Backoffice',
        console: 'Consola',
        manual: 'Manual',
        spike: 'Spike',
        native_app: 'App nativa',
      },
    },
    userPermissions: {
      title: 'Permisos de',
      cannotEditOwn: 'No puedes editar tus propios permisos',
      fields: {
        permission: 'Permiso',
        target: 'Sujeto',
        granted_by: 'Dado por',
        from: 'Desde',
      },
      create: 'Nuevo permiso para',
      whoHas: {
        title: 'Quien tiene...',
      }
    },
    nav: {
      general: 'Detalles',
      edit: 'Editar',
      orders: 'Pedidos',
      communications: 'Comunicaciones',
      promotions: 'Promos',
      addresses: 'Direcciones',
      mgm: 'MGM',
      permissions: 'Permisos',
      oldBackoffice: 'Backoffice antiguo',
      oldBackofficeBadge: 'TEMPORAL',
      auditLogs: 'Audit Logs',
    },
    auditLogs: {
      title: 'Audit Logs',
      noData: 'No hay registros de auditoría para este usuario',
      system: 'Sistema / Cola',
      fields: {
        date: 'Fecha',
        action: 'Acción',
        changedFields: 'Campos modificados',
        changedBy: 'Realizado por',
        ip: 'IP',
      },
    },
    userEdit: {
      title: 'Editar usuario',
      invoiceEmails: 'Emails de facturación',
      invoiceEmailsHint: 'Escribe un email y pulsa Enter para añadir',
      adminSection: 'Configuración admin',
      passwordSection: 'Contraseña',
      password: 'Nueva contraseña',
      passwordConfirmation: 'Confirmar contraseña',
      passwordHint: 'Dejar vacío para mantener la contraseña actual',
      confirmPhone: 'Confirmar número de teléfono (ignorar validación de formato)',
      deleteDialog: {
        title: 'Eliminar usuario',
        description: 'Esta acción anonimizará los datos del usuario. No se puede deshacer fácilmente.',
        confirmLabel: 'Escribe "borrar" para confirmar',
        confirmHint: 'Aceptado: delete, borrar, esborra',
      },
    },
    mgm: {
      title: 'Member Get Member',
      invitedBy: 'Invitado por',
      usersInvited: 'Usuarios invitados',
      notInvited: 'Este usuario no fue invitado por nadie',
      noInvitations: 'Este usuario no ha invitado a nadie',
      fields: {
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        registered: 'Registrado',
      },
    },
    addresses: {
      title: 'Direcciones de',
      create: 'Nueva dirección',
      createTitle: 'Crear dirección',
      editTitle: 'Editar dirección',
      deleteTitle: 'Eliminar dirección',
      deleteConfirm: '¿Estás seguro de que quieres eliminar esta dirección?',
      billing: 'Facturación',
      delivery: 'Envío',
      setDefaultBilling: 'Establecer como dirección de facturación',
      unsetDefaultBilling: 'Quitar como dirección de facturación',
      setDefaultDelivery: 'Establecer como dirección de envío',
      unsetDefaultDelivery: 'Quitar como dirección de envío',
      fields: {
        name: 'Nombre',
        address: 'Dirección',
        line_1: 'Dirección línea 1',
        line_2: 'Dirección línea 2',
        city: 'Ciudad',
        postcode: 'Código postal',
        country: 'ID País',
        phone: 'Teléfono',
        type: 'Tipo',
        accessCode: 'Código de acceso',
      },
      types: {
        residential: 'Residencial',
        commercial: 'Comercial',
      },
    },
  },
  webhooks: {
    action: 'Acción',
    created_by: 'Creado por',
    createDialog: {
      title: "Crear nuevo webhook",
      url: "URL",
      action: "Alcance",
      secret: {
        title: "Headers",
        placeholder: "Authorization: Bearer xxx\nConnection: keep-alive",
        hint: "'nombre: valor'. Cada linea es un header diferente. El nombre no puede tener espacios ni estar entre comillas (caracteres \" y ')",
      }
    },
    errorDialog: {
      title: "Ha pasado algo",
      text: "Por favor, contacta con el administrador"
    },
    sampleCallCTA: 'Enviar peticion de prueba',
    title: 'Webhooks',
    titleOf: 'Webhooks de',
    webhook: 'Webhook',
  },
  routes: {
    list: {
      title: 'Rutas de reparto',
      driver: 'Conductor',
      start_address: 'Dirección inicio',
      end_address: 'Dirección fin',
      hops: 'Paradas',
    },
    status: {
      in_delivery: 'En reparto',
      finished: 'Finalizada',
    },
    create: {
      title: 'Crear ruta',
      driver: 'Conductor',
      city: 'Ciudad',
      channel: 'Canal',
      channels: 'Canales',
      starting_location: 'Ubicación de inicio',
      starting_location_hint: 'Opcional. Establece el origen de ruta para la parada A.',
      all_cities_hint: 'Todas las ciudades incluidas',
      smart_routing: 'Planificación inteligente',
      auto_channels: 'Canales autoasignados',
      no_channel_filter: 'Sin filtros automáticos de canal',
      driver_filter_hint: 'Se aplican automáticamente los canales disponibles para este conductor.',
      all_cities: 'Todas las ciudades',
      visible_orders: 'visibles',
      selected_orders: 'seleccionados',
      available_orders: 'Pedidos disponibles',
      routed_orders: 'Pedidos en ruta',
      warning_order_tooltip: 'Pedido pendiente de pago o con pago rechazado, y listo para reparto o ya en ruta.',
      no_orders_selected: 'Selecciona pedidos de la tabla superior para añadirlos a la ruta.',
      order_count: 'pedido | pedidos',
      customer: 'Cliente',
      location: 'Ubicación',
      sp: 'Proveedor de servicio',
      extra_stops: 'Paradas extra',
      extra_stops_hint: 'Paradas sin pedido activo que el conductor igualmente debe completar.',
      extra_stop_placeholder: 'Nombre de la parada...',
      add_extra_stop: 'Añadir parada extra',
      route_address_error: 'No se pudo calcular la ruta. Revisa que las direcciones de las paradas extra sean válidas y se puedan enrutar.',
      add_all: 'Añadir todos',
      move_up: 'Subir parada',
      move_down: 'Bajar parada',
    },
    edit: {
      title: 'Editar ruta',
      visible: 'Visible',
      blocked: 'Bloqueada',
    },
    detail: {
      title: 'Ruta',
      driver: 'Conductor',
      hops: 'Paradas',
      legs_title: 'Paradas de la ruta',
      waypoint: 'Parada',
      orders_on_leg: 'Pedidos',
      no_orders_on_leg: 'No hay pedidos asociados a esta parada.',
      no_legs: 'Sin paradas calculadas.',
      orders_title: 'Pedidos en la ruta',
      unassigned_orders_title: 'Pedidos sin asociar automáticamente a una parada',
      not_found: 'Ruta no encontrada.',
      direction_delivery: 'Entrega',
      direction_collect: 'Recogida',
      destination_location: 'Localización destino',
      order_document: 'Documento',
      order_document_hint: 'Abrir documento asociado',
      extra_stop: 'Parada extra',
      extra_stop_badge: 'Sin pedido',
      mark_as_visited: 'Marcar como visitada',
      leg_visited: 'Parada visitada',
      progress: '{visited} de {total} paradas visitadas',
      next_stop: 'Siguiente',
      go_to_next: 'Ir a parada',
      all_visited: 'Todas las paradas visitadas',
    },
    delete: {
      title: 'Eliminar ruta',
      confirm: '¿Seguro que quieres eliminar esta ruta? Los pedidos volverán a su estado anterior.',
    },
    starting_locations: {
      title: 'Ubicaciones de inicio',
      add_title: 'Añadir ubicación de inicio',
      add: 'Añadir ubicación',
      name: 'Nombre',
      name_placeholder: 'Ej. Almacén, Oficina...',
      search_address: 'Buscar dirección',
      find: 'Buscar',
      map_hint: 'Haz clic en el mapa para fijar el punto de inicio',
      empty: 'Aún no hay ubicaciones de inicio guardadas',
      delete_confirm_title: '¿Eliminar ubicación de inicio?',
      no_maps_key: 'La clave de API de Google Maps no está configurada.',
      maps_error: 'No se pudo cargar Google Maps.',
      geocode_error: 'Dirección no encontrada.',
    },
    extra_stops: {
      title: 'Parada extra',
      name: 'Nombre de la parada',
      name_placeholder: 'Ej. Punto Vinted, Recogida almacén...',
      search_address: 'Dirección real',
      map_hint: 'Busca una dirección real o haz clic en el mapa para fijar la parada',
      unnamed: 'Parada sin nombre',
    },
  },

  products: {
    title: 'Productos',
    newProduct: 'Nuevo producto',
    editProduct: 'Editar producto',
    viewApiDocs: 'Ver documentación API',
    apiTitle: 'API — Productos',
    apiAlert: 'Reemplaza {token} por tu token de acceso. El usuario y la community se resuelven desde el contexto de sesión en b1.',
    createOrderTitle: 'Crear orden de pago único',
    pending: 'pendiente',
    copy: 'Copiar',
    copyId: 'Copiar identificador',
    empty: 'Sin productos',
    emptyHint: 'Crea el primer producto usando el botón de arriba',
    search: 'Buscar',
    serviceProvider: 'Service Provider',
    name: 'Nombre',
    description: 'Descripción',
    price: 'Precio',
    type: 'Tipo',
    active: 'Activo',
    inactive: 'Inactivo',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    deactivate: 'Desactivar',
    oneTime: 'Pago único',
    headers: {
      id: 'ID',
      provider: 'Provider',
      identifier: 'Identificador',
      name: 'Nombre',
      type: 'Tipo',
      price: 'Precio',
      status: 'Estado',
    },
  },

reports: {
  users: {
    title: 'Usuarios',
    description: 'Análisis de usuarios y comportamiento',
  },
  lockers: {
    title: 'Lockers',
    description: 'Informe de uso y estadísticas de casilleros',
  },
  ops_deliveries: {
    title: 'OPS - Entregas',
    description: 'Métricas operativas de entregas',
  },
  landing_page: {
    title: 'Página de Inicio',
    description: 'Rendimiento y conversión de la página de inicio',
  },
  amenities: {
    title: 'Servicios',
    description: 'Estadísticas de uso de servicios',
  },
  general: {
    title: 'Informes Generales',
    subtitle: 'Descarga exportaciones de datos operativos en formato CSV.',
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
    downloadCsv: 'Descargar CSV',
    downloadError: 'Error al descargar. Por favor, inténtalo de nuevo.',
    advertisingConsent: {
      title: 'Usuarios con Consentimiento Publicitario',
      description: 'Exporta una lista de usuarios filtrada por estado de consentimiento publicitario y canal.',
      channel: 'Canal',
      allChannels: 'Todos los canales',
      consentGiven: 'Consentimiento publicitario',
      yes: 'Consentimiento dado',
      no: 'Consentimiento no dado',
    },
    lockerUptime: {
      title: 'Uptime de Lockers',
      description: 'Exporta estadísticas de disponibilidad de lockers para un rango de fechas.',
      hint: 'La descarga incluye % uptime, eventos de caída e interacciones por locker.',
    },
    registrations: {
      title: 'Registros de Usuarios',
      description: 'Exporta el número de registros por canal para un rango de fechas.',
    },
  },
  registrations: {
    title: 'Registros de usuarios',
    loadError: 'No se han podido cargar los registros. Inténtalo de nuevo.',
    channel: 'Canal',
    signUps: 'Registros',
    total: 'Total',
    monthly: {
      title: 'Registros mensuales por canal',
      subtitle: 'Últimos 12 meses, incluido el mes en curso.',
      totalCaption: 'registros en 12 meses',
      unit: 'registros',
      month: 'Mes',
      others: 'Otros',
      empty: 'No hay registros en los últimos 12 meses',
    },
    period: {
      title: 'Registros por canal en un periodo',
      subtitle: 'Número de usuarios registrados en cada canal entre las dos fechas, ambas incluidas.',
      search: 'Consultar',
    },
  },
},

  rentbackSettings: {
    nextMonthNote: 'Los cambios entrarán en vigor el día 1 del mes siguiente.',
  },
  helpdesk: {
    ticketStatus: {
      open:     'Abierto y en proceso',
      pending:  'Pendiente de gestión externa',
      resolved: 'Resuelto',
      closed:   'Cerrado/Inválido',
    },
    ticketStatusShort: {
      open:     'En proceso',
      pending:  'Gestión externa',
      resolved: 'Resuelto',
      closed:   'Cerrado/Inválido',
    },
    dashboard: {
      weeklySub:   'Últimos 3 meses, semanas de lunes a domingo · color = estado actual de esos tickets',
      weekOf:      'Semana del {date}',
      weekCurrent: 'en curso',
      weekCreated: 'creados',
      openTicketsSub: 'En proceso o en gestión externa, más nuevos primero',
      kpiOpen:        'En proceso',
      kpiOpenHint:    'Creados en los últimos 3 meses y que el equipo está gestionando',
      kpiPending:     'Gestión externa',
      kpiPendingHint: 'Esperando a alguien de fuera del equipo (cliente, proveedor…)',
      kpiPendingNote: 'gestión externa',
      kpiDone:        'Resueltos y cerrados',
      kpiDoneHint:    'Tickets de los últimos 3 meses ya resueltos, cerrados o marcados como inválidos',
    },
    ticket: {
      goToEmail: 'Ir al email',
      showMore:  'Ver completo',
      showLess:  'Ver menos',
      newEmail:      'Nuevo',
      newEmailTitle: 'Llegó sin leer: se ha marcado como leído al abrir el ticket',
    },
    tickets: {
      unreadLabel:      'Emails',
      unreadFilter:     'Con respuestas sin leer',
      sortLabel:        'Orden',
      sortCreated:      'Creación',
      sortLastEmail:    'Último email recibido',
      unreadBadge:      '{n} sin leer',
      unreadBadgeTitle: 'Emails del hilo del ticket que aún no se han leído',
    },
    ticketCreate: {
      createType:  'Crear tipo «{name}»',
      typeCreated: 'Tipo de ticket «{name}» creado',
      noTypes:     'Escribe para buscar o crear un tipo',
    },
    inbox: {
      archive:     'Archivar',
      unarchive:   'Desarchivar',
      archived:    'Archivado',
      archiveHint: 'Ya revisado: deja de salir en Todos y en los demás filtros, solo en Archivados',
      reply: {
        title:              'Responder a {to}',
        to:                 'Para',
        invalidEmail:       'Email no válido: {emails}',
        tooManyRecipients:  'Demasiados destinatarios: no pueden superar los 255 caracteres en total',
        includeHistory:     'Incluir el mensaje original',
        includeHistoryHint: 'Cita el correo al que respondes, para quien no ha visto el hilo (p. ej. el cliente de un correo reenviado)',
      },
      defaults: {
        title:       'Filtros predeterminados',
        hintEmpty:   'Guarda los filtros y la cuenta actuales para verlos siempre al abrir el inbox.',
        hintSaved:   'Al abrir el inbox se aplican tus filtros guardados.',
        save:        'Guardar filtros actuales como predeterminados',
        apply:       'Volver a mis filtros predeterminados',
        clear:       'Quitar filtros predeterminados',
        saved:       'Filtros predeterminados guardados',
        cleared:     'Filtros predeterminados eliminados',
        saveError:   'No se han podido guardar los filtros predeterminados',
      },
    },
    whatsapp: {
      close:    'Cerrar',
      cancel:   'Cancelar',
      optional: 'opcional',
      required: 'Requerido',
      back:     'Volver a los chats',
      newConversation:     'Nuevo chat',
      businessNumber:      'Número de empresa: {phone}',
      notConfigured:       'WhatsApp no está configurado en el helpdesk: puedes ver los chats, pero no enviar mensajes.',
      emptyList:           'No hay chats con estos filtros',
      selectConversation:  'Selecciona un chat',
      resolve:             'Resolver',
      resolveHint:         'Marca el chat como resuelto. Si el cliente vuelve a escribir, se reabre solo.',
      conversationStarted: 'Chat iniciado',
      filters: {
        all:        'Todos',
        everyone:   'Todos',
        mine:       'Míos',
        unassigned: 'Sin asignar',
        search:     'Buscar por nombre, teléfono o mensaje…',
      },
      status: {
        open:     'Abierto',
        pending:  'Pendiente',
        resolved: 'Resuelto',
        closed:   'Cerrado',
      },
      messageStatus: {
        received:  'Recibido',
        queued:    'Enviando',
        sent:      'Enviado',
        delivered: 'Entregado',
        read:      'Leído',
        failed:    'No enviado',
      },
      messageType: {
        text:        'Mensaje',
        image:       'Foto',
        audio:       'Audio',
        video:       'Vídeo',
        document:    'Documento',
        sticker:     'Sticker',
        location:    'Ubicación',
        contacts:    'Contacto',
        template:    'Plantilla',
        button:      'Respuesta de botón',
        interactive: 'Respuesta interactiva',
        reaction:    'Reacción',
        unsupported: 'Mensaje no soportado',
      },
      message: {
        template:    'Plantilla: {name}',
        file:        'Archivo',
        image:       'Imagen',
        audio:       'Audio',
        video:       'Vídeo',
        document:    'Documento',
        location:    'Ubicación',
        download:    'Descargar',
        mediaError:  'No se ha podido descargar el archivo',
        mediaGone:   'Archivo no disponible (WhatsApp ya no lo conserva)',
        unsupported: 'Tipo de mensaje que WhatsApp no permite mostrar aquí',
        failed:      'No se ha podido enviar',
      },
      thread: {
        loadOlder: 'Cargar mensajes anteriores',
        empty:     'Todavía no hay mensajes',
        today:     'Hoy',
        yesterday: 'Ayer',
      },
      composer: {
        placeholder:        'Escribe un mensaje',
        captionPlaceholder: 'Añade un comentario (opcional)',
        send:               'Enviar',
        attach:             'Adjuntar archivo',
        removeFile:         'Quitar archivo',
        sendTemplate:       'Enviar plantilla',
        hint:               'Intro para enviar, Mayús+Intro para salto de línea',
        windowUntil:        'puedes escribir libremente hasta el {date}',
        windowClosed:       'Han pasado más de 24 h desde el último mensaje del cliente: WhatsApp solo permite enviar una plantilla aprobada.',
        fileTooBig:         'El archivo supera los 16 MB que permite WhatsApp',
        imageTooBig:        'Las imágenes no pueden superar los 5 MB en WhatsApp',
      },
      templates: {
        title:        'Enviar plantilla',
        newTitle:     'Nuevo chat de WhatsApp',
        phone:        'Teléfono (con prefijo de país)',
        name:         'Nombre del contacto',
        template:     'Plantilla aprobada',
        none:         'No hay plantillas aprobadas en Meta',
        variable:     'Variable {n}',
        preview:      'Vista previa',
        invalidPhone: 'Teléfono no válido: incluye el prefijo del país (p. ej. +34)',
      },
      details: {
        title:        'Detalles',
        status:       'Estado',
        assignee:     'Responsable',
        ticket:       'Ticket',
        openTicket:   'Abrir ticket #{id}',
        createTicket: 'Crear ticket',
        unlinkTicket: 'Desvincular ticket',
        contact:      'Contacto',
        name:         'Nombre',
        phone:        'Teléfono',
        copyPhone:    'Copiar teléfono',
        phoneCopied:  'Teléfono copiado',
        window:       'Ventana de 24 h',
        windowOpen:   'Abierta hasta el {date}',
        windowClosed: 'Cerrada: solo plantillas',
        windowHint:   'WhatsApp solo deja escribir libremente durante 24 h desde el último mensaje del cliente.',
        created:      'Creado el',
        lastMessage:  'Último mensaje el',
      },
    },
  },
};

export default messages;
